function onYouTubeIframeAPIReady() {
    theme.Video.loadVideos()
}
window.theme = window.theme || {}, window.theme = window.theme || {}, theme.Sections = function() {
        this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
    }, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function(t, e) {
            var i = $(t),
                a = i.attr("data-section-id"),
                r = i.attr("data-section-type");
            if (e = e || this.constructors[r], !_.isUndefined(e)) {
                var s = _.assignIn(new e(t), {
                    id: a,
                    type: r,
                    container: t
                });
                this.instances.push(s)
            }
        },
        _onSectionLoad: function(t) {
            var e = $("[data-section-id]", t.target)[0];
            e && this._createInstance(e)
        },
        _onSectionUnload: function(t) {
            this.instances = _.filter(this.instances, function(e) {
                var i = e.id === t.detail.sectionId;
                return i && _.isFunction(e.onUnload) && e.onUnload(t), !i
            })
        },
        _onSelect: function(t) {
            var e = _.find(this.instances, function(e) {
                return e.id === t.detail.sectionId
            });
            !_.isUndefined(e) && _.isFunction(e.onSelect) && e.onSelect(t)
        },
        _onDeselect: function(t) {
            var e = _.find(this.instances, function(e) {
                return e.id === t.detail.sectionId
            });
            !_.isUndefined(e) && _.isFunction(e.onDeselect) && e.onDeselect(t)
        },
        _onBlockSelect: function(t) {
            var e = _.find(this.instances, function(e) {
                return e.id === t.detail.sectionId
            });
            !_.isUndefined(e) && _.isFunction(e.onBlockSelect) && e.onBlockSelect(t)
        },
        _onBlockDeselect: function(t) {
            var e = _.find(this.instances, function(e) {
                return e.id === t.detail.sectionId
            });
            !_.isUndefined(e) && _.isFunction(e.onBlockDeselect) && e.onBlockDeselect(t)
        },
        register: function(t, e) {
            this.constructors[t] = e, $("[data-section-type=" + t + "]").each(function(t, i) {
                this._createInstance(i, e)
            }.bind(this))
        }
    }), window.slate = window.slate || {}, slate.utils = {
        getParameterByName: function(t, e) {
            e || (e = window.location.href), t = t.replace(/[[\]]/g, "\\$&");
            var i = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)").exec(e);
            return i ? i[2] ? decodeURIComponent(i[2].replace(/\+/g, " ")) : "" : null
        },
        keyboardKeys: {
            TAB: 9,
            ENTER: 13,
            ESCAPE: 27,
            LEFTARROW: 37,
            RIGHTARROW: 39
        }
    }, window.slate = window.slate || {}, slate.rte = {
        wrapTable: function(t) {
            t.$tables.wrap('<div class="' + t.tableWrapperClass + '"></div>')
        },
        wrapIframe: function(t) {
            t.$iframes.each(function() {
                $(this).wrap('<div class="' + t.iframeWrapperClass + '"></div>'), this.src = this.src
            })
        }
    }, window.slate = window.slate || {}, slate.a11y = {
        pageLinkFocus: function(t) {
            var e = "js-focus-hidden";
            t.first().attr("tabIndex", "-1").focus().addClass(e).one("blur", function() {
                t.first().removeClass(e).removeAttr("tabindex")
            })
        },
        focusHash: function() {
            var t = window.location.hash;
            t && document.getElementById(t.slice(1)) && this.pageLinkFocus($(t))
        },
        bindInPageLinks: function() {
            $("a[href*=#]").on("click", function(t) {
                this.pageLinkFocus($(t.currentTarget.hash))
            }.bind(this))
        },
        trapFocus: function(t) {
            var e = {
                    focusin: t.namespace ? "focusin." + t.namespace : "focusin",
                    focusout: t.namespace ? "focusout." + t.namespace : "focusout",
                    keydown: t.namespace ? "keydown." + t.namespace : "keydown.handleFocus"
                },
                i = t.$container.find($('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])').filter(":visible")),
                a = i[0],
                r = i[i.length - 1];
            t.$elementToFocus || (t.$elementToFocus = t.$container), t.$container.attr("tabindex", "-1"), t.$elementToFocus.focus(), $(document).off("focusin"), $(document).on(e.focusout, function() {
                $(document).off(e.keydown)
            }), $(document).on(e.focusin, function(t) {
                t.target !== r && t.target !== a || $(document).on(e.keydown, function(t) {
                    ! function(t) {
                        t.keyCode === slate.utils.keyboardKeys.TAB && (t.target !== r || t.shiftKey || (t.preventDefault(), a.focus()), t.target === a && t.shiftKey && (t.preventDefault(), r.focus()))
                    }(t)
                })
            })
        },
        removeTrapFocus: function(t) {
            var e = t.namespace ? "focusin." + t.namespace : "focusin";
            t.$container && t.$container.length && t.$container.removeAttr("tabindex"), $(document).off(e)
        },
        accessibleLinks: function(t) {
            var e = document.querySelector("body"),
                i = {
                    newWindow: "a11y-new-window-message",
                    external: "a11y-external-message",
                    newWindowExternal: "a11y-new-window-external-message"
                };
            void 0 !== t.$links && t.$links.jquery || (t.$links = $("a[href]:not([aria-describedby])")), $.each(t.$links, function() {
                    var t = $(this),
                        e = t.attr("target"),
                        a = t.attr("rel"),
                        r = function(t) {
                            var e = window.location.hostname;
                            return t[0].hostname !== e
                        }(t),
                        s = "_blank" === e;
                    r && t.attr("aria-describedby", i.external), s && (void 0 !== a && -1 !== a.indexOf("noopener") || t.attr("rel", function(t, e) {
                        return (void 0 === e ? "" : e + " ") + "noopener"
                    }), t.attr("aria-describedby", i.newWindow)), r && s && t.attr("aria-describedby", i.newWindowExternal)
                }),
                function(t) {
                    "object" != typeof t && (t = {});
                    var a = $.extend({
                            newWindow: "Opens in a new window.",
                            external: "Opens external website.",
                            newWindowExternal: "Opens external website in a new window."
                        }, t),
                        r = document.createElement("ul"),
                        s = "";
                    for (var n in a) s += "<li id=" + i[n] + ">" + a[n] + "</li>";
                    r.setAttribute("hidden", !0), r.innerHTML = s, e.appendChild(r)
                }(t.messages)
        }
    }, theme.Images = function() {
        return {
            preload: function(t, e) {
                "string" == typeof t && (t = [t]);
                for (var i = 0; i < t.length; i++) {
                    var a = t[i];
                    this.loadImage(this.getSizedImageUrl(a, e))
                }
            },
            loadImage: function(t) {
                (new Image).src = t
            },
            switchImage: function(t, e, i) {
                var a = this.imageSize(e.src),
                    r = this.getSizedImageUrl(t.src, a);
                i ? i(r, t, e) : e.src = r
            },
            imageSize: function(t) {
                var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
                return null !== e ? void 0 !== e[2] ? e[1] + e[2] : e[1] : null
            },
            getSizedImageUrl: function(t, e) {
                if (null === e) return t;
                if ("master" === e) return this.removeProtocol(t);
                var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null !== i) {
                    var a = t.split(i[0]),
                        r = i[0];
                    return this.removeProtocol(a[0] + "_" + e + r)
                }
                return null
            },
            removeProtocol: function(t) {
                return t.replace(/http(s)?:/, "")
            }
        }
    }(), theme.Currency = function() {
        var t = "${{amount}}";
        return {
            formatMoney: function(e, i) {
                "string" == typeof e && (e = e.replace(".", ""));
                var a = "",
                    r = /\{\{\s*(\w+)\s*\}\}/,
                    s = i || t;

                function n(t, e, i, a) {
                    if (i = i || ",", a = a || ".", isNaN(t) || null === t) return 0;
                    var r = (t = (t / 100).toFixed(e)).split(".");
                    return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (r[1] ? a + r[1] : "")
                }
                switch (s.match(r)[1]) {
                    case "amount":
                        a = n(e, 2);
                        break;
                    case "amount_no_decimals":
                        a = n(e, 0);
                        break;
                    case "amount_with_comma_separator":
                        a = n(e, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        a = n(e, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        a = n(e, 0, " ");
                        break;
                    case "amount_with_apostrophe_separator":
                        a = n(e, 2, "'")
                }
                return s.replace(r, a)
            }
        }
    }(), slate.Variants = function() {
        function t(t) {
            this.$container = t.$container, this.product = t.product, this.singleOptionSelector = t.singleOptionSelector, this.originalSelectorId = t.originalSelectorId, this.enableHistoryState = t.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _getCurrentOptions: function() {
                var t = _.map($(this.singleOptionSelector, this.$container), function(t) {
                    var e = $(t),
                        i = e.attr("type"),
                        a = {};
                    return "radio" === i || "checkbox" === i ? !!e[0].checked && (a.value = e.val(), a.index = e.data("index"), a) : (a.value = e.val(), a.index = e.data("index"), a)
                });
                return t = _.compact(t)
            },
            _getVariantFromOptions: function() {
                var t = this._getCurrentOptions(),
                    e = this.product.variants;
                return _.find(e, function(e) {
                    return t.every(function(t) {
                        return _.isEqual(e[t.index], t.value)
                    })
                })
            },
            _onSelectChange: function() {
                var t = this._getVariantFromOptions();
                this.$container.trigger({
                    type: "variantChange",
                    variant: t
                }), t && (this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t), this._updateSKU(t), this.currentVariant = t, this.enableHistoryState && this._updateHistoryState(t))
            },
            _updateImages: function(t) {
                if(typeof( t.featured_image) != "undefined" &&  t.featured_image !== null) {
                 var featured_image_id = t.featured_image.id;
                 var ind = $('.product-single__photo[data-image-id="'+featured_image_id+'"]').parent().parent().attr('data-slick-index');
                  $('.pro-main-img').slick('slickGoTo', ind); 
                }
                var e = t.featured_image || {},
                    i = this.currentVariant.featured_image || {};
                t.featured_image && e.src !== i.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: t
                })
            },
            _updatePrice: function(t) {
                t.price === this.currentVariant.price && t.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                    type: "variantPriceChange",
                    variant: t
                })
            },
            _updateSKU: function(t) {
                t.sku !== this.currentVariant.sku && this.$container.trigger({
                    type: "variantSKUChange",
                    variant: t
                })
            },
            _updateHistoryState: function(t) {
                if (history.replaceState && t) {
                    var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id;
                    window.history.replaceState({
                        path: e
                    }, "", e)
                }
            },
            _updateMasterSelect: function(t) {
                $(this.originalSelectorId, this.$container).val(t.id)
            }
        }), t
    }(), theme.Drawers = function() {
        function t(t, e, i) {
            var a = {
                close: ".js-drawer-close",
                open: ".js-drawer-open-" + e,
                openClass: "js-drawer-open",
                dirOpenClass: "js-drawer-open-" + e
            };
            if (this.nodes = {
                    $parent: $("html").add("body"),
                    $page: $("#PageContainer")
                }, this.config = $.extend(a, i), this.position = e, this.$drawer = $("#" + t), !this.$drawer.length) return !1;
            this.drawerIsOpen = !1, this.init()
        }
        return t.prototype.init = function() {
            $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.close, $.proxy(this.close, this))
        }, t.prototype.open = function(t) {
            var e = !1;
            return t ? t.preventDefault() : e = !0, t && t.stopPropagation && (t.stopPropagation(), this.$activeSource = $(t.currentTarget)), this.drawerIsOpen && !e ? this.close() : (this.$drawer.prepareTransition(), this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, slate.a11y.trapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (e || this.config.onDrawerOpen()), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents(), this)
        }, t.prototype.close = function() {
            this.drawerIsOpen && ($(document.activeElement).trigger("blur"), this.$drawer.prepareTransition(), this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"), this.drawerIsOpen = !1, slate.a11y.removeTrapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.unbindEvents(), this.config.onDrawerClose && "function" == typeof this.config.onDrawerClose && this.config.onDrawerClose())
        }, t.prototype.bindEvents = function() {
            this.nodes.$parent.on("keyup.drawer", $.proxy(function(t) {
                return 27 !== t.keyCode || (this.close(), !1)
            }, this)), this.nodes.$page.on("touchmove.drawer", function() {
                return !1
            }), this.nodes.$page.on("click.drawer", $.proxy(function() {
                return this.close(), !1
            }, this))
        }, t.prototype.unbindEvents = function() {
            this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer")
        }, t
    }(), window.theme = window.theme || {}, theme.Header = function() {
        var t = {
                body: "body",
                multicurrencySelector: "[data-currency-selector]",
                navigation: "#AccessibleNav",
                siteNavHasDropdown: "[data-has-dropdowns]",
                siteNavChildLinks: ".site-nav__child-link",
                siteNavActiveDropdown: ".site-nav--active-dropdown",
                siteNavHasCenteredDropdown: ".site-nav--has-centered-dropdown",
                siteNavCenteredDropdown: ".site-nav__dropdown--centered",
                siteNavLinkMain: ".site-nav__link--main",
                siteNavChildLink: ".site-nav__link--last",
                siteNavDropdown: ".site-nav__dropdown",
                siteHeader: ".site-header"
            },
            e = {
                activeClass: "site-nav--active-dropdown",
                childLinkClass: "site-nav__child-link",
                rightDropdownClass: "site-nav__dropdown--right",
                leftDropdownClass: "site-nav__dropdown--left"
            },
            i = {};

        function a(a) {
            a.find(t.siteNavLinkMain).attr("aria-expanded", "false"), a.removeClass(e.activeClass), i.$activeDropdown = $(t.siteNavActiveDropdown), $(t.body).off("click.siteNav"), $(window).off("keyup.siteNav")
        }

        function r(a) {
            a.each(function() {
                var a = $(this).find(t.siteNavDropdown);
                a.length && (Math.ceil($(this).offset().left) > Math.floor(i.$siteHeader.outerWidth()) / 2 ? a.removeClass(e.leftDropdownClass).addClass(e.rightDropdownClass) : a.removeClass(e.rightDropdownClass).addClass(e.leftDropdownClass))
            })
        }

        function s() {
            $(t.siteNavHasCenteredDropdown).each(function() {
                var e = $(this),
                    i = e.find(t.siteNavCenteredDropdown),
                    a = e.position().top + 41;
                i.css("top", a)
            })
        }
        return {
            init: function() {
                i = {
                    $nav: $(t.navigation),
                    $topLevel: $(t.siteNavLinkMain),
                    $parents: $(t.navigation).find(t.siteNavHasDropdown),
                    $subMenuLinks: $(t.siteNavChildLinks),
                    $activeDropdown: $(t.siteNavActiveDropdown),
                    $siteHeader: $(t.siteHeader)
                }, r($(t.siteNavHasDropdown)), s(), i.$parents.on("click.siteNav", function() {
                    var r = $(this);
                    r.hasClass(e.activeClass) ? a(r) : function(r) {
                        r.addClass(e.activeClass), i.$activeDropdown.length && a(i.$activeDropdown), i.$activeDropdown = r, r.find(t.siteNavLinkMain).attr("aria-expanded", "true"), setTimeout(function() {
                            $(window).on("keyup.siteNav", function(t) {
                                27 === t.keyCode && a(r)
                            }), $(t.body).on("click.siteNav", function() {
                                a(r)
                            })
                        }, 250)
                    }(r)
                }), $(t.siteNavChildLink).on("focusout.siteNav", function() {
                    setTimeout(function() {
                        !$(document.activeElement).hasClass(e.childLinkClass) && i.$activeDropdown.length && a(i.$activeDropdown)
                    })
                }), i.$topLevel.on("focus.siteNav", function() {
                    i.$activeDropdown.length && a(i.$activeDropdown)
                }), i.$subMenuLinks.on("click.siteNav", function(t) {
                    t.stopImmediatePropagation()
                }), $(t.multicurrencySelector).on("change", function() {
                    $(this).parents("form").submit()
                }), $(window).resize($.debounce(50, function() {
                    r($(t.siteNavHasDropdown)), s()
                }))
            },
            unload: function() {
                $(window).off(".siteNav"), i.$parents.off(".siteNav"), i.$subMenuLinks.off(".siteNav"), i.$topLevel.off(".siteNav"), $(t.siteNavChildLink).off(".siteNav"), $(t.body).off(".siteNav")
            }
        }
    }(), window.theme = window.theme || {}, theme.MobileNav = function() {
        var t, e, i, a = {
                mobileNavOpenIcon: "mobile-nav--open",
                mobileNavCloseIcon: "mobile-nav--close",
                navLinkWrapper: "mobile-nav__item",
                navLink: "mobile-nav__link",
                subNavLink: "mobile-nav__sublist-link",
                return: "mobile-nav__return-btn",
                subNavActive: "is-active",
                subNavClosing: "is-closing",
                navOpen: "js-menu--is-open",
                subNavShowing: "sub-nav--is-open",
                thirdNavShowing: "third-nav--is-open",
                subNavToggleBtn: "js-toggle-submenu"
            },
            r = {},
            s = 1,
            n = "screen and (max-width: 991px)";

        function o() {
            var t;
            r.$mobileNavToggle.hasClass(a.mobileNavCloseIcon) ? c() : (t = r.$siteHeader.outerHeight(), r.$mobileNavContainer.prepareTransition().addClass(a.navOpen), r.$mobileNavContainer.css({
                transform: "translateY(" + t + "px)"
            }), r.$pageContainer.css({
                transform: "translate3d(0, " + r.$mobileNavContainer[0].scrollHeight + "px, 0)"
            }), slate.a11y.trapFocus({
                $container: r.$sectionHeader,
                $elementToFocus: r.$mobileNavToggle,
                namespace: "navFocus"
            }), r.$mobileNavToggle.addClass(a.mobileNavCloseIcon).removeClass(a.mobileNavOpenIcon).attr("aria-expanded", !0), $(window).on("keyup.mobileNav", function(t) {
                27 === t.which && c()
            }))
        }

        function c() {
            r.$mobileNavContainer.prepareTransition().removeClass(a.navOpen), r.$mobileNavContainer.css({
                transform: "translateY(-100%)"
            }), r.$pageContainer.removeAttr("style"), slate.a11y.trapFocus({
                $container: $("html"),
                $elementToFocus: $("body")
            }), r.$mobileNavContainer.one("TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle", function() {
                slate.a11y.removeTrapFocus({
                    $container: r.$mobileNav,
                    namespace: "navFocus"
                })
            }), r.$mobileNavToggle.addClass(a.mobileNavOpenIcon).removeClass(a.mobileNavCloseIcon).attr("aria-expanded", !1).focus(), $(window).off("keyup.mobileNav"), scrollTo(0, 0)
        }

        function d(n) {
            if (!t) {
                var o = $(n.currentTarget),
                    c = o.hasClass(a.return);
                t = !0, c ? ($("." + a.subNavToggleBtn + '[data-level="' + (s - 1) + '"]').removeClass(a.subNavActive), i && i.length && i.removeClass(a.subNavActive)) : o.addClass(a.subNavActive), i = o,
                    function(i) {
                        var n = i ? $('.mobile-nav__dropdown[data-parent="' + i + '"]') : r.$mobileNav;
                        s = n.data("level") ? n.data("level") : 1, e && e.length && e.prepareTransition().addClass(a.subNavClosing);
                        e = n;
                        var o = n.outerHeight(),
                            c = s > 2 ? a.thirdNavShowing : a.subNavShowing;
                        r.$mobileNavContainer.css("height", o).removeClass(a.thirdNavShowing).addClass(c), i || r.$mobileNavContainer.removeClass(a.thirdNavShowing).removeClass(a.subNavShowing);
                        var d = 1 === s ? r.$sectionHeader : n,
                            l = n.find("[data-menu-title=" + s + "]"),
                            u = l || n;
                        r.$mobileNavContainer.one("TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle", function() {
                            slate.a11y.trapFocus({
                                $container: d,
                                $elementToFocus: u,
                                namespace: "subNavFocus"
                            }), r.$mobileNavContainer.off(".subnavToggle"), t = !1
                        }), r.$pageContainer.css({
                            transform: "translateY(" + o + "px)"
                        }), e.removeClass(a.subNavClosing)
                    }(o.data("target"))
            }
        }
        return {
            init: function() {
                (r = {
                    $pageContainer: $("#PageContainer"),
                    $siteHeader: $(".site-header"),
                    $mobileNavToggle: $(".js-mobile-nav-toggle"),
                    $mobileNavContainer: $(".mobile-nav-wrapper"),
                    $mobileNav: $("#MobileNav"),
                    $sectionHeader: $("#shopify-section-header"),
                    $subNavToggleBtn: $("." + a.subNavToggleBtn)
                }).$mobileNavToggle.on("click", o), r.$subNavToggleBtn.on("click.subNav", d), enquire.register(n, {
                    unmatch: function() {
                        r.$mobileNavContainer.hasClass(a.navOpen) && c()
                    }
                })
            },
            closeMobileNav: c
        }
    }(jQuery), window.theme = window.theme || {}, theme.Search = function() {
        var t = {
                search: ".search",
                searchSubmit: ".search__submit",
                searchInput: ".search__input",
                siteHeader: ".site-header",
                siteHeaderSearchToggle: ".site-header__search-toggle",
                siteHeaderSearch: ".site-header__search",
                searchDrawer: ".search-bar",
                searchDrawerInput: ".search-bar__input",
                searchHeader: ".search-header",
                searchHeaderInput: ".search-header__input",
                searchHeaderSubmit: ".search-header__submit",
                searchResultSubmit: "#SearchResultSubmit",
                searchResultInput: "#SearchInput",
                searchResultMessage: "[data-search-error-message]",
                mobileNavWrapper: ".mobile-nav-wrapper"
            },
            e = {
                focus: "search--focus",
                hidden: "hide",
                mobileNavIsOpen: "js-menu--is-open",
                searchTemplate: "template-search"
            };

        function i() {
            a($(t.searchDrawerInput)), $(t.mobileNavWrapper).hasClass(e.mobileNavIsOpen) && theme.MobileNav.closeMobileNav()
        }

        function a(t) {
            t.focus(), t[0].setSelectionRange(0, t[0].value.length)
        }

        function r() {
            $(t.siteHeaderSearchToggle).focus()
        }

        function s(t) {
            0 === this.$searchResultInput.val().trim().length ? (void 0 !== t && t.preventDefault(), a(this.$searchResultInput), function() {
                this.$searchErrorMessage.removeClass(e.hidden), this.$searchResultInput.attr("aria-describedby", "error-search-form").attr("aria-invalid", !0)
            }.call(this)) : function() {
                this.$searchErrorMessage.addClass(e.hidden), this.$searchResultInput.removeAttr("aria-describedby").removeAttr("aria-invalid")
            }.call(this)
        }
        return {
            init: function() {
                $(t.siteHeader).length && (this.$searchResultInput = $(t.searchResultInput), this.$searchErrorMessage = $(t.searchResultMessage), $("#PageContainer").addClass("drawer-page-content"), $(".js-drawer-open-top").attr("aria-controls", "SearchDrawer").attr("aria-expanded", "false").attr("aria-haspopup", "dialog"), theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", {
                    onDrawerOpen: i,
                    onDrawerClose: r
                }), null !== slate.utils.getParameterByName("q") && $("body").hasClass(e.searchTemplate) && s.call(this), $(t.searchResultSubmit).on("click", s.bind(this)), $(t.searchHeaderInput).add(t.searchHeaderSubmit).on("focus blur", function() {
                    $(t.searchHeader).toggleClass(e.focus)
                }), $(t.siteHeaderSearchToggle).on("click", function() {
                    var e = $(t.siteHeader).outerHeight(),
                        i = $(t.siteHeader).offset().top - e;
                    $(t.searchDrawer).css({
                        height: e + "px",
                        top: i + "px"
                    })
                }))
            }
        }
    }(),
    function() {
        var t = $(".return-link");

        function e(t) {
            var e = document.createElement("a");
            return e.ref = t, e.hostname
        }
        document.referrer && t.length && window.history.length && t.one("click", function(t) {
            t.preventDefault();
            var i = e(document.referrer);
            return e(window.location.href) === i && history.back(), !1
        })
    }(), theme.Slideshow = function() {
        this.$slideshow = null;
        var t = {
                slideshow: "slideshow",
                slickActiveMobile: "slick-active-mobile",
                controlsHover: "slideshow__controls--hover",
                isPaused: "is-paused"
            },
            e = {
                section: ".shopify-section",
                wrapper: "#SlideshowWrapper-",
                slides: ".slideshow__slide",
                textWrapperMobile: ".slideshow__text-wrap--mobile",
                textContentMobile: ".slideshow__text-content--mobile",
                controls: ".slideshow__controls",
                pauseButton: ".slideshow__pause",
                dots: ".slick-dots",
                arrows: ".slideshow__arrows",
                arrowsMobile: ".slideshow__arrows--mobile",
                arrowLeft: ".slideshow__arrow-left",
                arrowRight: ".slideshow__arrow-right"
            };

        function i(i, r) {
            var s = this.$slideshow = $(i);
            this.adaptHeight = this.$slideshow.data("adapt-height"), this.$wrapper = this.$slideshow.closest(e.wrapper + r), this.$section = this.$wrapper.closest(e.section), this.$controls = this.$wrapper.find(e.controls), this.$arrows = this.$section.find(e.arrows), this.$arrowsMobile = this.$section.find(e.arrowsMobile), this.$pause = this.$controls.find(e.pauseButton), this.$textWrapperMobile = this.$section.find(e.textWrapperMobile), this.autorotate = this.$slideshow.data("autorotate");
            var n = this.$slideshow.data("speed"),
                o = this.$slideshow.data("slide-nav-a11y");
            this.settings = {
                    accessibility: !0,
                    arrows: !1,
                    dots: !0,
                    fade: !0,
                    draggable: !0,
                    touchThreshold: 20,
                    autoplay: this.autorotate,
                    autoplaySpeed: n,
                    appendDots: this.$arrows,
                    customPaging: function(t, i) {
                        return '<a href="' + e.wrapper + r + '" aria-label="' + o.replace("[slide_number]", i + 1) + '" data-slide-number="' + i + '"></a>'
                    }
                }, this.$slideshow.on("beforeChange", function(e, i, a, r) {
                    var s = this.$dots.find("a"),
                        n = this.$mobileDots.find("li");
                    s.removeAttr("aria-current").eq(r).attr("aria-current", "true"), n.removeClass(t.slickActiveMobile).eq(r).addClass(t.slickActiveMobile), this.showMobileText(r)
                }.bind(this)), this.$slideshow.on("init", function(i, r) {
                    var s = r.$slider,
                        n = r.$list;
                    this.$dots = this.$section.find(e.dots), this.$mobileDots = this.$dots.eq(1), n.removeAttr("aria-live"), this.$wrapper.on("keyup", a.bind(this)), this.$controls.on("keyup", a.bind(this)), this.$textWrapperMobile.on("keyup", a.bind(this)), this.$wrapper.on("focusin", function(t) {
                        this.$wrapper.has(t.target).length && (n.attr("aria-live", "polite"), this.autorotate && s.slick("slickPause"))
                    }.bind(this)).on("focusout", function(t) {
                        this.$wrapper.has(t.target).length && (n.removeAttr("aria-live"), this.autorotate && (this.$pause.is(".is-paused") || s.slick("slickPlay")))
                    }.bind(this)), this.$dots && this.$dots.find("a").each(function() {
                        var t = $(this);
                        t.on("click keyup", function(t) {
                            if ("keyup" !== t.type || t.which === slate.utils.keyboardKeys.ENTER) {
                                t.preventDefault();
                                var e = $(t.target).data("slide-number");
                                s.attr("tabindex", -1).slick("slickGoTo", e), "keyup" === t.type && s.focus()
                            }
                        })
                    }).eq(0).attr("aria-current", "true");
                    this.$controls.on("focusin", function() {
                        this.$controls.addClass(t.controlsHover)
                    }.bind(this)).on("focusout", function() {
                        this.$controls.removeClass(t.controlsHover)
                    }.bind(this))
                }.bind(this)), this.$slideshow.on("init", function() {
                    this.$mobileDots.find("li:first-of-type").addClass(t.slickActiveMobile), this.showMobileText(0)
                }.bind(this)), this.autorotate && $(document).scroll($.debounce(250, function() {
                    this.$arrowsMobile.offset().top + this.$arrowsMobile.outerHeight() < window.pageYOffset ? s.slick("slickPause") : this.$pause.hasClass(t.isPaused) || s.slick("slickPlay")
                }.bind(this))), this.adaptHeight && (this.setSlideshowHeight(), $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)))), this.$slideshow.slick(this.settings),
                function() {
                    this.$slideshow.find(e.slides).removeAttr("role").removeAttr("aria-labelledby"), this.$dots.removeAttr("role").find("li").removeAttr("role").removeAttr("aria-selected").each(function() {
                        var t = $(this),
                            e = t.attr("aria-controls");
                        t.removeAttr("aria-controls").find("a").attr("aria-controls", e)
                    })
                }.bind(this)(), this.$arrows.find(e.arrowLeft).on("click", function() {
                    s.slick("slickPrev")
                }), this.$arrows.find(e.arrowRight).on("click", function() {
                    s.slick("slickNext")
                }), this.$pause.on("click", this.togglePause.bind(this))
        }

        function a() {
            event.keyCode === slate.utils.keyboardKeys.LEFTARROW && this.$slideshow.slick("slickPrev"), event.keyCode === slate.utils.keyboardKeys.RIGHTARROW && this.$slideshow.slick("slickNext")
        }
        return i.prototype.togglePause = function() {
            var e = "#Slideshow-" + this.$pause.data("id");
            this.$pause.hasClass(t.isPaused) ? (this.$pause.removeClass(t.isPaused).attr("aria-pressed", "false"), this.autorotate && $(e).slick("slickPlay")) : (this.$pause.addClass(t.isPaused).attr("aria-pressed", "true"), this.autorotate && $(e).slick("slickPause"))
        }, i.prototype.setSlideshowHeight = function() {
            var t = this.$slideshow.data("min-aspect-ratio");
            this.$slideshow.height($(document).width() / t)
        }, i.prototype.showMobileText = function(t) {
            var i = this.$textWrapperMobile.find(e.textContentMobile),
                a = e.textContentMobile + "-" + t,
                r = this.$textWrapperMobile.find(a);
            r.length || 1 !== this.$slideshow.find(e.slides).length ? this.$textWrapperMobile.show() : this.$textWrapperMobile.hide(), i.hide(), r.show()
        }, i
    }(), theme.Video = function() {
        var t = !1,
            e = !1,
            i = !1,
            a = !1,
            r = {},
            s = [],
            n = {
                ratio: 16 / 9,
                scrollAnimationDuration: 400,
                playerVars: {
                    iv_load_policy: 3,
                    modestbranding: 1,
                    autoplay: 0,
                    controls: 0,
                    wmode: "opaque",
                    branding: 0,
                    autohide: 0,
                    rel: 0
                },
                events: {
                    onReady: function(t) {
                        t.target.setPlaybackQuality("hd1080");
                        var e = g(t),
                            i = t.target.getVideoData().title;
                        p(), $("#" + e.id).attr("tabindex", "-1"), _(), a = e.$videoWrapper, r = i, s = a.find(c.playVideoBtn), n = a.find(c.closeVideoBtn), d = a.find(c.pauseVideoBtn), l = n.find(c.fallbackText), h = d.find(c.pauseVideoStop).find(c.fallbackText), m = d.find(c.pauseVideoResume).find(c.fallbackText), s.each(function() {
                            var t = $(this),
                                e = t.find(c.fallbackText);
                            e.text(e.text().replace("[video_title]", r))
                        }), l.text(l.text().replace("[video_title]", r)), h.text(h.text().replace("[video_title]", r)), m.text(m.text().replace("[video_title]", r)), "background" === e.type && (t.target.mute(), u(e.id));
                        var a, r, s, n, d, l, h, m;
                        e.$videoWrapper.addClass(o.loaded)
                    },
                    onStateChange: function(e) {
                        var i = g(e);
                        "background" !== i.status || C() || t || e.data !== YT.PlayerState.PLAYING && e.data !== YT.PlayerState.BUFFERING || (h(!0), t = !0, i.$videoWrapper.removeClass(o.loading));
                        switch (e.data) {
                            case YT.PlayerState.ENDED:
                                ! function(t) {
                                    switch (t.type) {
                                        case "background":
                                            s[t.id].seekTo(0);
                                            break;
                                        case "image_with_play":
                                            v(t.id), b(t.id, !1)
                                    }
                                }(i);
                                break;
                            case YT.PlayerState.PAUSED:
                                setTimeout(function() {
                                    e.target.getPlayerState() === YT.PlayerState.PAUSED && f(i)
                                }, 200)
                        }
                    }
                }
            },
            o = {
                playing: "video-is-playing",
                paused: "video-is-paused",
                loading: "video-is-loading",
                loaded: "video-is-loaded",
                backgroundVideoWrapper: "video-background-wrapper",
                videoWithImage: "video--image_with_play",
                backgroundVideo: "video--background",
                userPaused: "is-paused",
                supportsAutoplay: "autoplay",
                supportsNoAutoplay: "no-autoplay",
                wrapperMinHeight: "video-section-wrapper--min-height"
            },
            c = {
                section: ".video-section",
                videoWrapper: ".video-section-wrapper",
                playVideoBtn: ".video-control__play",
                closeVideoBtn: ".video-control__close-wrapper",
                pauseVideoBtn: ".video__pause",
                pauseVideoStop: ".video__pause-stop",
                pauseVideoResume: ".video__pause-resume",
                fallbackText: ".icon__fallback-text"
            };

        function d(t) {
            (e || i) && t && "function" == typeof s[t].playVideo && u(t)
        }

        function l(t) {
            s[t] && "function" == typeof s[t].pauseVideo && s[t].pauseVideo()
        }

        function u(e, a) {
            var n = r[e],
                c = s[e],
                d = n.$videoWrapper;
            if (i) m(n);
            else {
                if (a || t) return d.removeClass(o.loading), m(n), void c.playVideo();
                c.playVideo()
            }
        }

        function h(e) {
            var a = e ? o.supportsAutoplay : o.supportsNoAutoplay;
            $(document.documentElement).removeClass(o.supportsAutoplay).removeClass(o.supportsNoAutoplay).addClass(a), e || (i = !0), t = !0
        }

        function p() {
            e || (C() && (i = !0), i && h(!1), e = !0)
        }

        function m(t) {
            var e = t.$videoWrapper,
                i = e.find(c.pauseVideoBtn);
            e.removeClass(o.loading), i.hasClass(o.userPaused) && i.removeClass(o.userPaused), "background" !== t.status && ($("#" + t.id).attr("tabindex", "0"), "image_with_play" === t.type && e.removeClass(o.paused).addClass(o.playing), setTimeout(function() {
                e.find(c.closeVideoBtn).focus()
            }, n.scrollAnimationDuration))
        }

        function f(t) {
            var e = t.$videoWrapper;
            "image_with_play" === t.type && ("closed" === t.status ? e.removeClass(o.paused) : e.addClass(o.paused)), e.removeClass(o.playing)
        }

        function v(t) {
            var e = r[t],
                i = e.$videoWrapper,
                a = [o.paused, o.playing].join(" ");
            switch (C() && i.removeAttr("style"), $("#" + e.id).attr("tabindex", "-1"), e.status = "closed", e.type) {
                case "image_with_play":
                    s[t].stopVideo(), f(e);
                    break;
                case "background":
                    s[t].mute(),
                        function(t) {
                            $("#" + t).removeClass(o.videoWithImage).addClass(o.backgroundVideo), r[t].$videoWrapper.addClass(o.backgroundVideoWrapper), r[t].status = "background", w($("#" + t))
                        }(t)
            }
            i.removeClass(a)
        }

        function g(t) {
            return r[t.target.a.id]
        }

        function b(t, e) {
            var i = r[t],
                a = i.$videoWrapper.offset().top,
                s = i.$videoWrapper.find(c.playVideoBtn),
                d = 0,
                l = 0;
            C() && i.$videoWrapper.parent().toggleClass("page-width", !e), e ? (l = C() ? $(window).width() / n.ratio : i.$videoWrapper.width() / n.ratio, d = ($(window).height() - l) / 2, i.$videoWrapper.removeClass(o.wrapperMinHeight).animate({
                height: l
            }, 600), C() && Shopify.designMode || $("html, body").animate({
                scrollTop: a - d
            }, n.scrollAnimationDuration)) : (l = C() ? i.$videoWrapper.data("mobile-height") : i.$videoWrapper.data("desktop-height"), i.$videoWrapper.height(i.$videoWrapper.width() / n.ratio).animate({
                height: l
            }, 600), setTimeout(function() {
                i.$videoWrapper.addClass(o.wrapperMinHeight)
            }, 600), s.focus())
        }

        function y(t) {
            var e = r[t];
            switch (e.$videoWrapper.addClass(o.loading), e.$videoWrapper.attr("style", "height: " + e.$videoWrapper.height() + "px"), e.status = "open", e.type) {
                case "image_with_play":
                    u(t, !0);
                    break;
                case "background":
                    ! function(t) {
                        $("#" + t).removeClass(o.backgroundVideo).addClass(o.videoWithImage), setTimeout(function() {
                            $("#" + t).removeAttr("style")
                        }, 600), r[t].$videoWrapper.removeClass(o.backgroundVideoWrapper).addClass(o.playing), r[t].status = "open"
                    }(t), s[t].unMute(), u(t, !0)
            }
            b(t, !0), $(document).on("keydown.videoPlayer", function(t) {
                var e = $(document.activeElement).data("controls");
                t.keyCode === slate.utils.keyboardKeys.ESCAPE && e && (v(e), b(e, !1))
            })
        }

        function _() {
            $("." + o.backgroundVideo).each(function(t, e) {
                w($(e))
            })
        }

        function w(t) {
            if (a)
                if (C()) t.removeAttr("style");
                else {
                    var e = t.closest(c.videoWrapper),
                        i = e.width(),
                        r = t.width(),
                        s = e.data("desktop-height");
                    i / n.ratio < s ? (r = Math.ceil(s * n.ratio), t.width(r).height(s).css({
                        left: (i - r) / 2,
                        top: 0
                    })) : (s = Math.ceil(i / n.ratio), t.width(i).height(s).css({
                        left: 0,
                        top: (s - s) / 2
                    })), t.prepareTransition(), e.addClass(o.loaded)
                }
        }

        function C() {
            return $(window).width() < 992 || window.mobileCheck()
        }

        function P() {
            $(document).on("click.videoPlayer", c.playVideoBtn, function(t) {
                y($(t.currentTarget).data("controls"))
            }), $(document).on("click.videoPlayer", c.closeVideoBtn, function(t) {
                var e = $(t.currentTarget).data("controls");
                $(t.currentTarget).blur(), v(e), b(e, !1)
            }), $(document).on("click.videoPlayer", c.pauseVideoBtn, function(t) {
                ! function(t) {
                    var e = r[t].$videoWrapper.find(c.pauseVideoBtn),
                        i = e.hasClass(o.userPaused);
                    i ? (e.removeClass(o.userPaused), d(t)) : (e.addClass(o.userPaused), l(t)), e.attr("aria-pressed", !i)
                }($(t.currentTarget).data("controls"))
            }), $(window).on("resize.videoPlayer", $.debounce(200, function() {
                if (a) {
                    var t, e = window.innerHeight === screen.height;
                    if (_(), C()) {
                        for (t in r) r.hasOwnProperty(t) && (r[t].$videoWrapper.hasClass(o.playing) && (e || (l(t), f(r[t]))), r[t].$videoWrapper.height($(document).width() / n.ratio));
                        h(!1)
                    } else
                        for (t in h(!0), r) r[t].$videoWrapper.find("." + o.videoWithImage).length || (s[t].playVideo(), m(r[t]))
                }
            })), $(window).on("scroll.videoPlayer", $.debounce(50, function() {
                if (a)
                    for (var t in r)
                        if (r.hasOwnProperty(t)) {
                            var e = r[t].$videoWrapper;
                            e.hasClass(o.playing) && (e.offset().top + .75 * e.height() < $(window).scrollTop() || e.offset().top + .25 * e.height() > $(window).scrollTop() + $(window).height()) && (v(t), b(t, !1))
                        }
            }))
        }

        function k(t) {
            var e = $.extend({}, n, r[t]);
            e.playerVars.controls = e.controls, s[t] = new YT.Player(t, e)
        }
        return {
            init: function(t) {
                if (t.length) {
                    if (r[t.attr("id")] = {
                            id: t.attr("id"),
                            videoId: t.data("id"),
                            type: t.data("type"),
                            status: "image_with_play" === t.data("type") ? "closed" : "background",
                            $video: t,
                            $videoWrapper: t.closest(c.videoWrapper),
                            $section: t.closest(c.section),
                            controls: "background" === t.data("type") ? 0 : 1
                        }, !a) {
                        var e = document.createElement("script");
                        e.src = "https://www.youtube.com/iframe_api";
                        var i = document.getElementsByTagName("script")[0];
                        i.parentNode.insertBefore(e, i)
                    }
                    p()
                }
            },
            editorLoadVideo: function(t) {
                a && (k(t), P())
            },
            loadVideos: function() {
                for (var t in r) r.hasOwnProperty(t) && k(t);
                P(), a = !0
            },
            playVideo: d,
            pauseVideo: l,
            removeEvents: function() {
                $(document).off(".videoPlayer"), $(window).off(".videoPlayer")
            }
        }
    }(), window.theme = window.theme || {}, theme.FormStatus = function() {
        var t = {
            statusMessage: "[data-form-status]"
        };
        return {
            init: function() {
                this.$statusMessage = $(t.statusMessage), this.$statusMessage && (this.$statusMessage.attr("tabindex", -1).focus(), this.$statusMessage.on("blur", function() {
                    this.$statusMessage.removeAttr("tabindex")
                }.bind(this)))
            }
        }
    }(), theme.Hero = function() {
        var t = {
                indexSectionFlush: "index-section--flush"
            },
            e = {
                heroFixedWidthContent: ".hero-fixed-width__content",
                heroFixedWidthImage: ".hero-fixed-width__image"
            };
        return function(i, a) {
            this.$hero = $(i), this.layout = this.$hero.data("layout");
            var r = $("#shopify-section-" + a),
                s = r.find(e.heroFixedWidthContent),
                n = r.find(e.heroFixedWidthImage);

            function o() {
                var t = s.height() + 50;
                t > n.height() && n.css("min-height", t)
            }
            "fixed_width" === this.layout && (r.removeClass(t.indexSectionFlush), o(), $(window).resize($.debounce(50, function() {
                o()
            })))
        }
    }(),
    function() {
        var t = $("#BlogTagFilter");
        t.length && t.on("change", function() {
            location.href = $(this).val()
        })
    }(), window.theme = theme || {}, theme.customerTemplates = function() {
        var t = {
            RecoverHeading: "#RecoverHeading",
            RecoverEmail: "#RecoverEmail",
            LoginHeading: "#LoginHeading"
        };

        function e() {
            this.$RecoverHeading = $(t.RecoverHeading), this.$RecoverEmail = $(t.RecoverEmail), this.$LoginHeading = $(t.LoginHeading), $("#RecoverPassword").on("click", function(t) {
                t.preventDefault(), i(), this.$RecoverHeading.attr("tabindex", "-1").focus()
            }.bind(this)), $("#HideRecoverPasswordLink").on("click", function(t) {
                t.preventDefault(), $("#RecoverPasswordForm").addClass("hide"), $("#CustomerLoginForm").removeClass("hide"), this.$LoginHeading.attr("tabindex", "-1").focus()
            }.bind(this)), this.$RecoverHeading.on("blur", function() {
                $(this).removeAttr("tabindex")
            }), this.$LoginHeading.on("blur", function() {
                $(this).removeAttr("tabindex")
            })
        }

        function i() {
            $("#RecoverPasswordForm").removeClass("hide"), $("#CustomerLoginForm").addClass("hide"), "true" === this.$RecoverEmail.attr("aria-invalid") && this.$RecoverEmail.focus()
        }
        return {
            init: function() {
                var t, a;
                e(),
                    function() {
                        "#recover" === window.location.hash && i.bind(this)()
                    }(), $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide").focus(), t = $("#AddressNewForm"), a = $("#AddressNewButton"), t.length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                        hideElement: "AddressProvinceContainerNew"
                    }), $(".address-country-option").each(function() {
                        var t = $(this).data("form-id"),
                            e = "AddressCountry_" + t,
                            i = "AddressProvince_" + t,
                            a = "AddressProvinceContainer_" + t;
                        new Shopify.CountryProvinceSelector(e, i, {
                            hideElement: a
                        })
                    }), $(".address-new-toggle").on("click", function() {
                        var e = "true" === a.attr("aria-expanded");
                        t.toggleClass("hide"), a.attr("aria-expanded", !e).focus()
                    }), $(".address-edit-toggle").on("click", function() {
                        var t = $(this).data("form-id"),
                            e = $("#EditFormButton_" + t),
                            i = $("#EditAddress_" + t),
                            a = "true" === e.attr("aria-expanded");
                        i.toggleClass("hide"), e.attr("aria-expanded", !a).focus()
                    }), $(".address-delete").on("click", function() {
                        var t = $(this),
                            e = t.data("target"),
                            i = t.data("confirm-message");
                        confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink(e, {
                            parameters: {
                                _method: "delete"
                            }
                        })
                    }))
            }
        }
    }(), window.theme = window.theme || {}, theme.Cart = function() {
        var t = {
                cartCount: "[data-cart-count]",
                cartCountBubble: "[data-cart-count-bubble]",
                cartDiscount: "[data-cart-discount]",
                cartDiscountTitle: "[data-cart-discount-title]",
                cartDiscountAmount: "[data-cart-discount-amount]",
                cartDiscountWrapper: "[data-cart-discount-wrapper]",
                cartErrorMessage: "[data-cart-error-message]",
                cartErrorMessageWrapper: "[data-cart-error-message-wrapper]",
                cartItem: "[data-cart-item]",
                cartItemDetails: "[data-cart-item-details]",
                cartItemDiscount: "[data-cart-item-discount]",
                cartItemDiscountedPriceGroup: "[data-cart-item-discounted-price-group]",
                cartItemDiscountTitle: "[data-cart-item-discount-title]",
                cartItemDiscountAmount: "[data-cart-item-discount-amount]",
                cartItemDiscountList: "[data-cart-item-discount-list]",
                cartItemFinalPrice: "[data-cart-item-final-price]",
                cartItemImage: "[data-cart-item-image]",
                cartItemLinePrice: "[data-cart-item-line-price]",
                cartItemOriginalPrice: "[data-cart-item-original-price]",
                cartItemPrice: "[data-cart-item-price]",
                cartItemPriceList: "[data-cart-item-price-list]",
                cartItemProperty: "[data-cart-item-property]",
                cartItemPropertyName: "[data-cart-item-property-name]",
                cartItemPropertyValue: "[data-cart-item-property-value]",
                cartItemRegularPriceGroup: "[data-cart-item-regular-price-group]",
                cartItemRegularPrice: "[data-cart-item-regular-price]",
                cartItemTitle: "[data-cart-item-title]",
                cartItemOption: "[data-cart-item-option]",
                cartLineItems: "[data-cart-line-items]",
                cartNote: "[data-cart-notes]",
                cartQuantityErrorMessage: "[data-cart-quantity-error-message]",
                cartQuantityErrorMessageWrapper: "[data-cart-quantity-error-message-wrapper]",
                cartRemove: "[data-cart-remove]",
                cartStatus: "[data-cart-status]",
                cartSubtotal: "[data-cart-subtotal]",
                cartTableCell: "[data-cart-table-cell]",
                cartWrapper: "[data-cart-wrapper]",
                emptyPageContent: "[data-empty-page-content]",
                quantityInput: "[data-quantity-input]",
                quantityInputMobile: "[data-quantity-input-mobile]",
                quantityInputDesktop: "[data-quantity-input-desktop]",
                quantityLabelMobile: "[data-quantity-label-mobile]",
                quantityLabelDesktop: "[data-quantity-label-desktop]",
                inputQty: "[data-quantity-input]",
                thumbnails: ".cart__image",
                unitPrice: "[data-unit-price]",
                unitPriceBaseUnit: "[data-unit-price-base-unit]",
                unitPriceGroup: "[data-unit-price-group]"
            },
            e = {
                cartNoCookies: "cart--no-cookies",
                cartRemovedProduct: "cart__removed-product",
                hide: "hide",
                inputError: "input--error"
            },
            i = "data-cart-item-index",
            a = "data-cart-item-key",
            r = "data-cart-item-quantity",
            s = "data-cart-item-title",
            n = "data-cart-item-url",
            o = "data-quantity-item";
        theme.breakpoints = theme.breakpoints || {}, (isNaN(theme.breakpoints.medium) || void 0 === theme.breakpoints.medium) && (theme.breakpoints.medium = 992);
        var c = "(min-width: " + theme.breakpoints.medium + "px)";

        function d(i) {
            this.$container = $(i), this.$thumbnails = $(t.thumbnails, this.$container), this.ajaxEnabled = this.$container.data("ajax-enabled"), this.cookiesEnabled() || this.$container.addClass(e.cartNoCookies), this.$thumbnails.css("cursor", "pointer"), this.$container.on("click", t.thumbnails, this._handleThumbnailClick), this.$container.on("change", t.inputQty, $.debounce(500, this._handleInputQty.bind(this))), this.mql = window.matchMedia(c), this.mql.addListener(this.setQuantityFormControllers.bind(this)), this.setQuantityFormControllers(), this.ajaxEnabled && (this.$container.on("change", t.cartNote, this._onNoteChange.bind(this)), this.$container.on("click", t.cartRemove, this._onRemoveItem.bind(this)), this._setupCartTemplates())
        }
        return d.prototype = _.assignIn({}, d.prototype, {
            _setupCartTemplates: function() {
                this.$itemTemplate = $(t.cartItem, this.$container).first().clone(), this.$itemDiscountTemplate = $(t.cartItemDiscount, this.$itemTemplate).clone(), this.$itemOptionTemplate = $(t.cartItemOption, this.$itemTemplate).clone(), this.$itemPropertyTemplate = $(t.cartItemProperty, this.$itemTemplate).clone(), this.$itemPriceListTemplate = $(t.cartItemPriceList, this.$itemTemplate).clone(), this.$itemLinePriceTemplate = $(t.cartItemLinePrice, this.$itemTemplate).clone(), this.$cartDiscountTemplate = $(t.cartDiscount, this.$container).clone()
            },
            _handleInputQty: function(e) {
                var i = $(e.target),
                    a = i.data("quantity-item"),
                    r = i.closest(t.cartItem),
                    s = $("[data-quantity-item=" + a + "]"),
                    n = parseInt(i.val()),
                    o = !(n < 0 || isNaN(n));
                s.val(n), this._hideCartError(), this._hideQuantityErrorMessage(), o ? o && this.ajaxEnabled && this._updateItemQuantity(a, r, s, n) : this._showQuantityErrorMessages(r)
            },
            _updateItemQuantity: function(e, r, s, n) {
                var o = r.attr(a),
                    c = r.attr(i),
                    d = {
                        url: "/cart/change.js",
                        data: {
                            quantity: n,
                            line: c
                        },
                        dataType: "json"
                    };
                $.post(d).done(function(e) {
                    if (0 === e.item_count) this._emptyCart();
                    else if (this._createCart(e), 0 === n) this._showRemoveMessage(r.clone());
                    else {
                        var i = $('[data-cart-item-key="' + o + '"]'),
                            a = this.getItem(o, e);
                        $(t.quantityInput, i).focus(), this._updateLiveRegion(a), location.reload()
                    }
                    this._setCartCountBubble(e.item_count)
                }.bind(this)).fail(function() {
                    this._showCartError(s)
                }.bind(this))
            },
            getItem: function(t, e) {
                return e.items.find(function(e) {
                    return e.key === t
                })
            },
            _liveRegionText: function(t) {
                var e = theme.strings.update + ": [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]";
                e = e.replace("[QuantityLabel]", theme.strings.quantity).replace("[Quantity]", t.quantity);
                var i = "",
                    a = theme.Currency.formatMoney(t.original_line_price, theme.moneyFormat),
                    r = "",
                    s = "",
                    n = "";
                return t.original_line_price > t.final_line_price && (i = theme.strings.regularTotal, r = theme.strings.discountedTotal, s = theme.Currency.formatMoney(t.final_line_price, theme.moneyFormat), n = theme.strings.priceColumn), e = e.replace("[Regular]", i).replace("[$$]", a).replace("[DiscountedPrice]", r).replace("[$]", s).replace("[PriceInformation]", n).trim()
            },
            _updateLiveRegion: function(e) {
                var i = $(t.cartStatus);
                i.html(this._liveRegionText(e)).attr("aria-hidden", !1), setTimeout(function() {
                    i.attr("aria-hidden", !0)
                }, 1e3)
            },
            _createCart: function(i) {
                var a = this._createCartDiscountList(i);
                $(t.cartLineItems, this.$container).html(this._createLineItemList(i)), this.setQuantityFormControllers(), $(t.cartNote, this.$container).val(i.note), 0 === a.length ? $(t.cartDiscountWrapper, this.$container).html("").addClass(e.hide) : $(t.cartDiscountWrapper, this.$container).html(a).removeClass(e.hide), $(t.cartSubtotal, this.$container).html(theme.Currency.formatMoney(i.total_price, theme.moneyFormatWithCurrency))
            },
            _createCartDiscountList: function(e) {
                return $.map(e.cart_level_discount_applications, function(e) {
                    var i = this.$cartDiscountTemplate.clone();
                    return i.find(t.cartDiscountTitle).text(e.title), i.find(t.cartDiscountAmount).html(theme.Currency.formatMoney(e.total_allocated_amount, theme.moneyFormat)), i[0]
                }.bind(this))
            },
            _createLineItemList: function(e) {
                return $.map(e.items, function(e, i) {
                    var a = this.$itemTemplate.clone(),
                        r = this.$itemPriceListTemplate.clone();
                    this._setLineItemAttributes(a, e, i), this._setLineItemImage(a, e.featured_image), $(t.cartItemTitle, a).text(e.product_title).attr("href", e.url);
                    var s = this._createProductDetailsList(e.product_has_only_default_variant, e.options_with_values, e.properties);
                    this._setProductDetailsList(a, s), this._setItemRemove(a, e.title), r.html(this._createItemPrice(e.original_price, e.final_price, this.$itemPriceListTemplate)), e.unit_price_measurement && r.append(this._createUnitPrice(e.unit_price, e.unit_price_measurement, this.$itemPriceListTemplate)), this._setItemPrice(a, r);
                    var n = this._createItemDiscountList(e);
                    this._setItemDiscountList(a, n), this._setQuantityInputs(a, e, i);
                    var o = this._createItemPrice(e.original_line_price, e.final_line_price, this.$itemLinePriceTemplate);
                    return this._setItemLinePrice(a, o), a[0]
                }.bind(this))
            },
            _setLineItemAttributes: function(t, e, o) {
                t.attr(a, e.key).attr(n, e.url).attr(s, e.title).attr(i, o + 1).attr(r, e.quantity)
            },
            _setLineItemImage: function(i, a) {
                var r = $(t.cartItemImage, i),
                    s = null !== a.url ? theme.Images.getSizedImageUrl(a.url, "x190") : null;
                s ? r.attr("alt", a.alt).attr("src", s).removeClass(e.hide) : r.remove()
            },
            _setProductDetailsList: function(i, a) {
                var r = $(t.cartItemDetails, i);
                0 === a.length ? r.addClass(e.hide).text("") : r.removeClass(e.hide).html(a)
            },
            _setItemPrice: function(e, i) {
                $(t.cartItemPrice, e).html(i)
            },
            _setItemDiscountList: function(i, a) {
                var r = $(t.cartItemDiscountList, i);
                0 === a.length ? r.html("").addClass(e.hide) : r.html(a).removeClass(e.hide)
            },
            _setItemRemove: function(e, i) {
                $(t.cartRemove, e).attr("aria-label", theme.strings.removeLabel.replace("[product]", i))
            },
            _setQuantityInputs: function(e, i, a) {
                $(t.quantityInputMobile, e).attr("id", "updates_" + i.key).attr(o, a + 1).val(i.quantity), $(t.quantityInputDesktop, e).attr("id", "updates_large_" + i.key).attr(o, a + 1).val(i.quantity), $(t.quantityLabelMobile, e).attr("for", "updates_" + i.key), $(t.quantityLabelDesktop, e).attr("for", "updates_large_" + i.key)
            },
            setQuantityFormControllers: function() {
                this.mql.matches ? ($(t.quantityInputDesktop).attr("name", "updates[]"), $(t.quantityInputMobile).removeAttr("name")) : ($(t.quantityInputMobile).attr("name", "updates[]"), $(t.quantityInputDesktop).removeAttr("name"))
            },
            _setItemLinePrice: function(e, i) {
                $(t.cartItemLinePrice, e).html(i)
            },
            _createProductDetailsList: function(t, e, i) {
                var a = [];
                return t || (a = a.concat(this._getOptionList(e))), null !== i && 0 !== Object.keys(i).length && (a = a.concat(this._getPropertyList(i))), a
            },
            _getOptionList: function(t) {
                return $.map(t, function(t) {
                    var i = this.$itemOptionTemplate.clone();
                    return i.text(t.name + ": " + t.value).removeClass(e.hide), i[0]
                }.bind(this))
            },
            _getPropertyList: function(i) {
                var a = null !== i ? Object.entries(i) : [];
                return $.map(a, function(i) {
                    var a = this.$itemPropertyTemplate.clone();
                    if ("_" !== i[0].charAt(0) && 0 !== i[1].length) return a.find(t.cartItemPropertyName).text(i[0]), -1 === i[0].indexOf("/uploads/") ? a.find(t.cartItemPropertyValue).text(": " + i[1]) : a.find(t.cartItemPropertyValue).html(': <a href="' + i[1] + '"> ' + i[1].split("/").pop() + "</a>"), a.removeClass(e.hide), a[0]
                }.bind(this))
            },
            _createItemPrice: function(i, a, r) {
                if (i !== a) {
                    var s = $(t.cartItemDiscountedPriceGroup, r).clone();
                    return $(t.cartItemOriginalPrice, s).html(theme.Currency.formatMoney(i, theme.moneyFormat)), $(t.cartItemFinalPrice, s).html(theme.Currency.formatMoney(a, theme.moneyFormat)), s.removeClass(e.hide), s[0]
                }
                var n = $(t.cartItemRegularPriceGroup, r).clone();
                return $(t.cartItemRegularPrice, n).html(theme.Currency.formatMoney(i, theme.moneyFormat)), n.removeClass(e.hide), n[0]
            },
            _createUnitPrice: function(i, a, r) {
                var s = $(t.unitPriceGroup, r).clone(),
                    n = (1 !== a.reference_value ? a.reference_value : "") + a.reference_unit;
                return $(t.unitPriceBaseUnit, s).text(n), $(t.unitPrice, s).html(theme.Currency.formatMoney(i, theme.moneyFormat)), s.removeClass(e.hide), s[0]
            },
            _createItemDiscountList: function(e) {
                return $.map(e.line_level_discount_allocations, function(e) {
                    var i = this.$itemDiscountTemplate.clone();
                    return i.find(t.cartItemDiscountTitle).text(e.discount_application.title), i.find(t.cartItemDiscountAmount).html(theme.Currency.formatMoney(e.amount, theme.moneyFormat)), i[0]
                }.bind(this))
            },
            _showQuantityErrorMessages: function(i) {
                $(t.cartQuantityErrorMessage, i).text(theme.strings.quantityMinimumMessage), $(t.cartQuantityErrorMessageWrapper, i).removeClass(e.hide), $(t.inputQty, i).addClass(e.inputError).focus()
            },
            _hideQuantityErrorMessage: function() {
                var i = $(t.cartQuantityErrorMessageWrapper).addClass(e.hide);
                $(t.cartQuantityErrorMessage, i).text(""), $(t.inputQty, this.$container).removeClass(e.inputError)
            },
            _handleThumbnailClick: function(e) {
                var i = $(e.target).closest(t.cartItem).data("cart-item-url");
                window.location.href = i
            },
            _onNoteChange: function(t) {
                var e = t.currentTarget.value;
                this._hideCartError(), this._hideQuantityErrorMessage();
                var i = {
                    url: "/cart/update.js",
                    data: {
                        note: e
                    },
                    dataType: "json"
                };
                $.post(i).fail(function() {
                    this._showCartError(t.currentTarget)
                }.bind(this))
            },
            _showCartError: function(i) {
                $(t.cartErrorMessage).text(theme.strings.cartError), $(t.cartErrorMessageWrapper).removeClass(e.hide), i.focus()
            },
            _hideCartError: function() {
                $(t.cartErrorMessageWrapper).addClass(e.hide), $(t.cartErrorMessage).text("")
            },
            _onRemoveItem: function(e) {
                e.preventDefault();
                var a = $(e.target).closest(t.cartItem),
                    r = a.attr(i);
                this._hideCartError();
                var s = {
                    url: "/cart/change.js",
                    data: {
                        quantity: 0,
                        line: r
                    },
                    dataType: "json"
                };
                $.post(s).done(function(t) {
                    0 === t.item_count ? this._emptyCart() : (this._createCart(t), this._showRemoveMessage(a.clone())), this._setCartCountBubble(t.item_count)
                }.bind(this)).fail(function() {
                    this._showCartError(null)
                }.bind(this))
            },
            _showRemoveMessage: function(t) {
                var e, i = t.data("cart-item-index"),
                    a = this._getRemoveMessage(t);
                i - 1 == 0 ? (e = $('[data-cart-item-index="1"]', this.$container), $(a).insertBefore(e)) : (e = $('[data-cart-item-index="' + (i - 1) + '"]', this.$container), a.insertAfter(e)), a.focus()
            },
            _getRemoveMessage: function(i) {
                var a = this._formatRemoveMessage(i),
                    r = $(t.cartTableCell, i).clone();
                return r.removeClass().addClass(e.cartRemovedProduct).attr("colspan", "4").html(a), i.attr("role", "alert").html(r).attr("tabindex", "-1"), i
            },
            _formatRemoveMessage: function(t) {
                var e = t.data("cart-item-quantity"),
                    i = t.attr(n),
                    a = t.attr(s);
                return theme.strings.removedItemMessage.replace("[quantity]", e).replace("[link]", '<a href="' + i + '" class="text-link text-link--accent">' + a + "</a>")
            },
            _setCartCountBubble: function(i) {
                this.$cartCountBubble = this.$cartCountBubble || $(t.cartCountBubble), this.$cartCount = this.$cartCount || $(t.cartCount), i > 0 ? (this.$cartCountBubble.removeClass(e.hide), this.$cartCount.html(i)) : (this.$cartCountBubble.addClass(e.hide), this.$cartCount.html(""))
            },
            _emptyCart: function() {
                this.$emptyPageContent = this.$emptyPageContent || $(t.emptyPageContent, this.$container), this.$cartWrapper = this.$cartWrapper || $(t.cartWrapper, this.$container), this.$emptyPageContent.removeClass(e.hide), this.$cartWrapper.addClass(e.hide)
            },
            cookiesEnabled: function() {
                var t = navigator.cookieEnabled;
                return t || (document.cookie = "testcookie", t = -1 !== document.cookie.indexOf("testcookie")), t
            }
        }), d
    }(), window.theme = window.theme || {}, theme.Filters = function() {
        var t = "screen and (min-width: 992px)",
            e = {
                mainContent: "#MainContent",
                filterSelection: "#FilterTags",
                sortSelection: "#SortBy"
            },
            i = "data-default-sortby";

        function a(t) {
            var i = this.$container = $(t);
            this.$filterSelect = $(e.filterSelection, i), this.$sortSelect = $(e.sortSelection, i), this.$selects = $(e.filterSelection, i).add($(e.sortSelection, i)), this.defaultSort = this._getDefaultSortValue(), this.$selects.removeClass("hidden"), this.$filterSelect.on("change", this._onFilterChange.bind(this)), this.$sortSelect.on("change", this._onSortChange.bind(this)), this._initBreakpoints(), this._initParams()
        }
        return a.prototype = _.assignIn({}, a.prototype, {
            _initBreakpoints: function() {
                var e = this;
                enquire.register(t, {
                    match: function() {
                        e._resizeSelect(e.$selects)
                    }
                })
            },
            _initParams: function() {
                if (self.queryParams = {}, location.search.length)
                    for (var t, e = location.search.substr(1).split("&"), i = 0; i < e.length; i++)(t = e[i].split("=")).length > 1 && (self.queryParams[decodeURIComponent(t[0])] = decodeURIComponent(t[1]))
            },
            _onSortChange: function() {
                self.queryParams.sort_by = this._getSortValue(), self.queryParams.page && delete self.queryParams.page, window.location.search = decodeURIComponent($.param(self.queryParams))
            },
            _onFilterChange: function() {
                document.location.href = this._getFilterValue()
            },
            _getFilterValue: function() {
                return this.$filterSelect.val()
            },
            _getSortValue: function() {
                return this.$sortSelect.val() || this.defaultSort
            },
            _getDefaultSortValue: function() {
                return this.$sortSelect.attr(i)
            },
            _resizeSelect: function(t) {
                t.each(function() {
                    var t = $(this),
                        e = t.find("option:selected").text(),
                        i = $("<span>").html(e);
                    i.appendTo("body");
                    var a = i.width();
                    i.remove(), t.width(a + 10)
                })
            },
            onUnload: function() {
                this.$filterSelect.off("change", this._onFilterChange), this.$sortSelect.off("change", this._onSortChange)
            }
        }), a
    }(), window.theme = window.theme || {}, theme.HeaderSection = function() {
        function t() {
            theme.Header.init(), theme.MobileNav.init(), theme.Search.init()
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            onUnload: function() {
                theme.Header.unload()
            }
        }), t
    }(), theme.Maps = function() {
        var t = 14,
            e = null,
            i = [],
            a = {
                addressNoResults: theme.strings.addressNoResults,
                addressQueryLimit: theme.strings.addressQueryLimit,
                addressError: theme.strings.addressError,
                authError: theme.strings.authError
            },
            r = {
                section: '[data-section-type="map"]',
                map: "[data-map]",
                mapOverlay: "[data-map-overlay]"
            },
            s = "map-section--load-error",
            n = "map-section__error errors text-center";

        function o(t) {
            this.$container = $(t), this.$map = this.$container.find(r.map), this.key = this.$map.data("api-key"), void 0 !== this.key && ("loaded" === e ? this.createMap() : (i.push(this), "loading" !== e && (e = "loading", void 0 === window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function() {
                e = "loaded", $.each(i, function(t, e) {
                    e.createMap()
                })
            }))))
        }
        return window.gm_authFailure = function() {
            Shopify.designMode && ($(r.section).addClass(s), $(r.map).remove(), $(r.mapOverlay).after('<div class="' + n + '">' + theme.strings.authError + "</div>"))
        }, o.prototype = _.assignIn({}, o.prototype, {
            createMap: function() {
                var e = this.$map;
                return function(t) {
                    var e = $.Deferred(),
                        i = new google.maps.Geocoder,
                        a = t.data("address-setting");
                    return i.geocode({
                        address: a
                    }, function(t, i) {
                        i !== google.maps.GeocoderStatus.OK && e.reject(i), e.resolve(t)
                    }), e
                }(e).then(function(i) {
                    var a = {
                            zoom: t,
                            center: i[0].geometry.location,
                            draggable: !1,
                            clickableIcons: !1,
                            scrollwheel: !1,
                            disableDoubleClickZoom: !0,
                            disableDefaultUI: !0
                        },
                        r = this.map = new google.maps.Map(e[0], a),
                        s = this.center = r.getCenter();
                    new google.maps.Marker({
                        map: r,
                        position: r.getCenter()
                    });
                    google.maps.event.addDomListener(window, "resize", $.debounce(250, function() {
                        google.maps.event.trigger(r, "resize"), r.setCenter(s), e.removeAttr("style")
                    }))
                }.bind(this)).fail(function() {
                    var t;
                    switch (status) {
                        case "ZERO_RESULTS":
                            t = a.addressNoResults;
                            break;
                        case "OVER_QUERY_LIMIT":
                            t = a.addressQueryLimit;
                            break;
                        case "REQUEST_DENIED":
                            t = a.authError;
                            break;
                        default:
                            t = a.addressError
                    }
                    Shopify.designMode && e.parent().addClass(s).html('<div class="' + n + '">' + t + "</div>")
                })
            },
            onUnload: function() {
                0 !== this.$map.length && google.maps.event.clearListeners(this.map, "resize")
            }
        }), o
    }(), theme.Product = function() {
        function t(t) {
            var e = this.$container = $(t),
                i = e.attr("data-section-id");
            this.ajaxEnabled = e.data("ajax-enabled"), this.settings = {
                mediaQueryMediumUp: "screen and (min-width: 992px)",
                mediaQuerySmall: "screen and (max-width: 991px)",
                bpSmall: !1,
                enableHistoryState: e.data("enable-history-state") || !1,
                namespace: ".slideshow-" + i,
                sectionId: i,
                sliderActive: !1,
                zoomEnabled: !1
            }, this.selectors = {
                addToCart: "[data-add-to-cart]",
                addToCartText: "[data-add-to-cart-text]",
                cartCount: "[data-cart-count]",
                cartCountBubble: "[data-cart-count-bubble]",
                cartPopup: "[data-cart-popup]",
                cartPopupCartQuantity: "[data-cart-popup-cart-quantity]",
                cartPopupClose: "[data-cart-popup-close]",
                cartPopupDismiss: "[data-cart-popup-dismiss]",
                cartPopupImage: "[data-cart-popup-image]",
                cartPopupImageWrapper: "[data-cart-popup-image-wrapper]",
                cartPopupImagePlaceholder: "[data-cart-popup-image-placeholder]",
                cartPopupPlaceholderSize: "[data-placeholder-size]",
                cartPopupProductDetails: "[data-cart-popup-product-details]",
                cartPopupQuantity: "[data-cart-popup-quantity]",
                cartPopupQuantityLabel: "[data-cart-popup-quantity-label]",
                cartPopupTitle: "[data-cart-popup-title]",
                cartPopupWrapper: "[data-cart-popup-wrapper]",
                loader: "[data-loader]",
                loaderStatus: "[data-loader-status]",
                quantity: "[data-quantity-input]",
                SKU: ".variant-sku",
                productStatus: "[data-product-status]",
                originalSelectorId: "#ProductSelect-" + i,
                productForm: "[data-product-form]",
                errorMessage: "[data-error-message]",
                errorMessageWrapper: "[data-error-message-wrapper]",
                productImageWraps: ".product-single__photo",
                productThumbImages: ".product-single__thumbnail--" + i,
                productThumbs: ".product-single__thumbnails-" + i,
                productThumbListItem: ".product-single__thumbnails-item",
                productFeaturedImage: ".product-featured-img",
                productThumbsWrapper: ".thumbnails-wrapper",
                saleLabel: ".product-price__sale-label-" + i,
                singleOptionSelector: ".single-option-selector-" + i,
                shopifyPaymentButton: ".shopify-payment-button",
                priceContainer: "[data-price]",
                regularPrice: "[data-regular-price]",
                salePrice: "[data-sale-price]",
                unitPrice: "[data-unit-price]",
                unitPriceBaseUnit: "[data-unit-price-base-unit]",
                productPolicies: "[data-product-policies]"
            }, this.classes = {
                cartPopupWrapperHidden: "cart-popup-wrapper--hidden",
                hidden: "hide",
                visibilityHidden: "visibility-hidden",
                inputError: "input--error",
                productOnSale: "price--on-sale",
                productUnitAvailable: "price--unit-available",
                productUnavailable: "price--unavailable",
                productSoldOut: "price--sold-out",
                cartImage: "cart-popup-item__image",
                productFormErrorMessageWrapperHidden: "product-form__error-message-wrapper--hidden",
                activeClass: "active-thumb"
            }, this.$quantityInput = $(this.selectors.quantity, e), this.$errorMessageWrapper = $(this.selectors.errorMessageWrapper, e), this.$addToCart = $(this.selectors.addToCart, e), this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart), this.$shopifyPaymentButton = $(this.selectors.shopifyPaymentButton, e), this.$productPolicies = $(this.selectors.productPolicies, e), this.$loader = $(this.selectors.loader, this.$addToCart), this.$loaderStatus = $(this.selectors.loaderStatus, e), $("#ProductJson-" + i).html() && (this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML), this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass("js-zoom-enabled"), this._initBreakpoints(), this._stringOverrides(), this._initVariants(), this._initImageSwitch(), this._initAddToCart(), this._setActiveThumbnail())
        }
        return t.prototype = _.assignIn({}, t.prototype, {
            _stringOverrides: function() {
                theme.productStrings = theme.productStrings || {}, $.extend(theme.strings, theme.productStrings)
            },
            _initBreakpoints: function() {
                var t = this;
                enquire.register(this.settings.mediaQuerySmall, {
                    match: function() {
                        $(t.selectors.productThumbImages).length > 3 && t._initThumbnailSlider(), t.settings.zoomEnabled && $(t.selectors.productImageWraps).each(function() {
                            $(this).trigger("zoom.destroy")
                        }), t.settings.bpSmall = !0
                    },
                    unmatch: function() {
                        t.settings.sliderActive && t._destroyThumbnailSlider(), t.settings.bpSmall = !1
                    }
                }), enquire.register(this.settings.mediaQueryMediumUp, {
                    match: function() {
                        t.settings.zoomEnabled && $(t.selectors.productImageWraps).each(function() {
                            var t, e;
                            t = this, e = $(t).data("zoom"), $(t).zoom({
                                url: e
                            })
                        })
                    }
                })
            },
            _initVariants: function() {
                var t = {
                    $container: this.$container,
                    enableHistoryState: this.$container.data("enable-history-state") || !1,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.productSingleObject
                };
                this.variants = new slate.Variants(t), this.$container.on("variantChange" + this.settings.namespace, this._updateAvailability.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this))
            },
            _initImageSwitch: function() {
                if ($(this.selectors.productThumbImages).length) {
                    var t = this;
                    $(this.selectors.productThumbImages).on("click", function(e) {
                        e.preventDefault();
                        var i = $(this).data("thumbnail-id");
                        t._switchImage(i), t._setActiveThumbnail(i)
                    }).on("keyup", t._handleImageFocus.bind(t))
                }
            },
            _initAddToCart: function() {
                $(this.selectors.productForm, this.$container).on("submit", function(t) {
                    if (this.$addToCart.is("[aria-disabled]")) t.preventDefault();
                    else if (this.ajaxEnabled) {
                        t.preventDefault(), this.$previouslyFocusedElement = $(":focus");
                        var e = this.$quantityInput.val() <= 0;
                        if (e) this._showErrorMessage(theme.strings.quantityMinimumMessage);
                        else if (e || !this.ajaxEnabled);
                        else {
                            this._handleButtonLoadingState(!0);
                            var i = $(this.selectors.productForm, this.$container);
                            this._addItemToCart(i)
                        }
                    }
                }.bind(this))
            },
            _addItemToCart: function(t) {
                var e = {
                    url: "/cart/add.js",
                    data: $(t).serialize(),
                    dataType: "json"
                };
                $.post(e).done(function(e) {
                    this._hideErrorMessage(), this._setupCartPopup(e), $(t).find("#charger-checkbox").is(":checked") && $.post("/cart/add.js", {
                        items: [{
                            quantity: $(t).find(".qtyBox input").val(),
                            id: $(t).find("#charger-checkbox").data("variant-id")
                        }]
                    }).done(function(t) {
                        console.log(t), this._setupCartPopup(t)
                    })
                }.bind(this)).fail(function(t) {
                    this.$previouslyFocusedElement.focus();
                    var e = t.responseJSON ? t.responseJSON.description : theme.strings.cartError;
                    this._showErrorMessage(e), this._handleButtonLoadingState(!1)
                }.bind(this))
            },
            _handleButtonLoadingState: function(t) {
                t ? (this.$addToCart.attr("aria-disabled", !0), this.$addToCartText.addClass(this.classes.hidden), this.$loader.removeClass(this.classes.hidden), this.$shopifyPaymentButton.attr("disabled", !0), this.$loaderStatus.attr("aria-hidden", !1)) : (this.$addToCart.removeAttr("aria-disabled"), this.$addToCartText.removeClass(this.classes.hidden), this.$loader.addClass(this.classes.hidden), this.$shopifyPaymentButton.removeAttr("disabled"), this.$loaderStatus.attr("aria-hidden", !0))
            },
            _showErrorMessage: function(t) {
                $(this.selectors.errorMessage, this.$container).html(t), 0 !== this.$quantityInput.length && this.$quantityInput.addClass(this.classes.inputError), this.$errorMessageWrapper.removeClass(this.classes.productFormErrorMessageWrapperHidden).attr("aria-hidden", !0).removeAttr("aria-hidden")
            },
            _hideErrorMessage: function() {
                this.$errorMessageWrapper.addClass(this.classes.productFormErrorMessageWrapperHidden), 0 !== this.$quantityInput.length && this.$quantityInput.removeClass(this.classes.inputError)
            },
            _setupCartPopup: function(t) {
                this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup), this.$cartPopupWrapper = this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper), this.$cartPopupTitle = this.$cartPopupTitle || $(this.selectors.cartPopupTitle), this.$cartPopupQuantity = this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity), this.$cartPopupQuantityLabel = this.$cartPopupQuantityLabel || $(this.selectors.cartPopupQuantityLabel), this.$cartPopupClose = this.$cartPopupClose || $(this.selectors.cartPopupClose), this.$cartPopupDismiss = this.$cartPopupDismiss || $(this.selectors.cartPopupDismiss), this.$cartPopupImagePlaceholder = this.$cartPopupImagePlaceholder || $(this.selectors.cartPopupImagePlaceholder), this._setupCartPopupEventListeners(), this._updateCartPopupContent(t)
            },
            _updateCartPopupContent: function(t) {
                var e = this.$quantityInput.length ? this.$quantityInput.val() : 1;
                this.$cartPopupTitle.text(t.product_title), this.$cartPopupQuantity.text(e), this.$cartPopupQuantityLabel.text(theme.strings.quantityLabel.replace("[count]", e)), this._setCartPopupPlaceholder(t.featured_image.url, t.featured_image.aspect_ratio), this._setCartPopupImage(t.featured_image.url, t.featured_image.alt), this._setCartPopupProductDetails(t.product_has_only_default_variant, t.options_with_values, t.properties), $.getJSON("/cart.js").then(function(t) {
                    jQuery(".mini-cart-items").html(""), console.log(t);
                    var e = t,
                        i = e.item_count,
                        a = e.total_price / 100;
                    if (i > 0) {
                        jQuery(".cart-count").text(i), jQuery(".mini-cart").attr("id", "mini-cart"), jQuery(".mini-cart-subtotal .price").text("$" + a.toFixed(2));
                        var r = [];
                        $(e.items).each(function(t, e) {
                            e.id;
                            var i = e.product_title,
                                a = (e.handle, e.quantity),
                                s = e.price / 100,
                                n = e.url,
                                o = e.image,
                                c = e.variant_options,
                                d = [];
                            $(c).each(function(t, e) {
                                var i = e;
                                "Default Title" !== i && d.push(i + "<br>")
                            });
                            var l = d.join(""),
                                u = null != o ? '<img src="' + o + '"  alt="' + i + '" />' : "";
                            r.push('<div class="row mini-cart-product"><div class="col span_3 mini-image"><a href="' + n + '"><div class="product_image">' + u + '</a></div></div><div class="col span_9"><a href="' + n + '" >' + i + "<br>" + l + '</a> <span class="price">$' + s.toFixed(2) + "<br>x " + a + "</span></div></div>")
                        }), jQuery(".mini-cart-items").append(r.join("")), $("#mini-cart").show().delay(5e3).fadeOut()
                    }
                    this._setCartQuantity(t.item_count), this._setCartCountBubble(t.item_count), this._showCartPopup()
                }.bind(this))
            },
            _setupCartPopupEventListeners: function() {
                this.$cartPopupWrapper.on("keyup", function(t) {
                    t.keyCode === slate.utils.keyboardKeys.ESCAPE && this._hideCartPopup(t)
                }.bind(this)), this.$cartPopupClose.on("click", this._hideCartPopup.bind(this)), this.$cartPopupDismiss.on("click", this._hideCartPopup.bind(this)), $("body").on("click", this._onBodyClick.bind(this))
            },
            _setCartPopupPlaceholder: function(t, e) {
                if (this.$cartPopupImageWrapper = this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper), null !== t) {
                    var i = $(this.selectors.cartPopupPlaceholderSize),
                        a = 95 * e,
                        r = 100 / e;
                    this.$cartPopupImagePlaceholder.css("max-width", a), i.css("padding-top", r + "%")
                } else this.$cartPopupImageWrapper.addClass(this.classes.hidden)
            },
            _setCartPopupImage: function(t, e) {
                if (null !== t) {
                    this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
                    var i = theme.Images.getSizedImageUrl(t, "200x"),
                        a = document.createElement("img");
                    a.src = i, a.alt = e, a.classList.add(this.classes.cartImage), a.dataset.cartPopupImage = "", a.onload = function() {
                        this.$cartPopupImagePlaceholder.addClass(this.classes.hidden), this.$cartPopupImageWrapper.append(a)
                    }.bind(this)
                }
            },
            _setCartPopupProductDetails: function(t, e, i) {
                this.$cartPopupProductDetails = this.$cartPopupProductDetails || $(this.selectors.cartPopupProductDetails);
                var a = "";
                t || (a += this._getVariantOptionList(e)), null !== i && 0 !== Object.keys(i).length && (a += this._getPropertyList(i)), 0 === a.length ? (this.$cartPopupProductDetails.html(""), this.$cartPopupProductDetails.attr("hidden", "")) : (this.$cartPopupProductDetails.html(a), this.$cartPopupProductDetails.removeAttr("hidden"))
            },
            _getVariantOptionList: function(t) {
                var e = "";
                return t.forEach(function(t) {
                    e = e + '<li class="product-details__item product-details__item--variant-option">' + t.name + ": " + t.value + "</li>"
                }), e
            },
            _getPropertyList: function(t) {
                var e = "";
                return Object.entries(t).forEach(function(t) {
                    "_" !== t[0].charAt(0) && 0 !== t[1].length && (e = e + '<li class="product-details__item product-details__item--property"><span class="product-details__property-label">' + t[0] + ": </span>" + t[1])
                }), e
            },
            _setCartQuantity: function(t) {
                var e;
                this.$cartPopupCartQuantity = this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity), 1 === t ? e = theme.strings.oneCartCount : t > 1 && (e = theme.strings.otherCartCount.replace("[count]", t)), this.$cartPopupCartQuantity.text(t).attr("aria-label", e)
            },
            _setCartCountBubble: function(t) {
                this.$cartCountBubble = this.$cartCountBubble || $(this.selectors.cartCountBubble), this.$cartCount = this.$cartCount || $(this.selectors.cartCount), this.$cartCountBubble.removeClass(this.classes.hidden), this.$cartCount.text(t)
            },
            _showCartPopup: function() {
                this._handleButtonLoadingState(!1), slate.a11y.trapFocus({
                    $container: this.$cartPopupWrapper,
                    $elementToFocus: this.$cartPopup,
                    namespace: "cartPopupFocus"
                })
            },
            _hideCartPopup: function(t) {
                var e = 0 === t.detail;
                this.$cartPopupWrapper.prepareTransition().addClass(this.classes.cartPopupWrapperHidden), $(this.selectors.cartPopupImage).remove(), this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden), slate.a11y.removeTrapFocus({
                    $container: this.$cartPopupWrapper,
                    namespace: "cartPopupFocus"
                }), e && this.$previouslyFocusedElement[0].focus(), this.$cartPopupWrapper.off("keyup"), this.$cartPopupClose.off("click"), this.$cartPopupDismiss.off("click"), $("body").off("click")
            },
            _onBodyClick: function(t) {
                var e = $(t.target);
                e[0] === this.$cartPopupWrapper[0] || e.parents(this.selectors.cartPopup).length || this._hideCartPopup(t)
            },
            _setActiveThumbnail: function(t) {
                void 0 === t && (t = $(this.selectors.productImageWraps + ":not(.hide)", this.$container).data("image-id"));
                var e = $(this.selectors.productThumbListItem + ":not(.slick-cloned)", this.$container),
                    i = e.find(this.selectors.productThumbImages + "[data-thumbnail-id='" + t + "']");
                if ($(this.selectors.productThumbImages).removeClass(this.classes.activeClass).removeAttr("aria-current"), i.addClass(this.classes.activeClass), i.attr("aria-current", !0), e.hasClass("slick-slide")) {
                    var a = i.parent().data("slick-index");
                    $(this.selectors.productThumbs).slick("slickGoTo", a, !0)
                }
            },
            _switchImage: function(t) {
                var e = $(this.selectors.productImageWraps + "[data-image-id='" + t + "']", this.$container),
                    i = $(this.selectors.productImageWraps + ":not([data-image-id='" + t + "'])", this.$container);
                e.removeClass(this.classes.hidden), i.addClass(this.classes.hidden)
            },
            _handleImageFocus: function(t) {
                t.keyCode === slate.utils.keyboardKeys.ENTER && $(this.selectors.productFeaturedImage + ":visible").focus()
            },
            _initThumbnailSlider: function() {
                var t = {
                    slidesToShow: 4,
                    slidesToScroll: 3,
                    infinite: !1,
                    prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
                    nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
                    responsive: [{
                        breakpoint: 321,
                        settings: {
                            slidesToShow: 3
                        }
                    }]
                };
                $(this.selectors.productThumbs).slick(t), $(this.selectors.productThumbsWrapper, this.$container).find(".slick-list").removeAttr("aria-live"), $(this.selectors.productThumbsWrapper, this.$container).find(".slick-disabled").removeAttr("aria-disabled"), this.settings.sliderActive = !0
            },
            _destroyThumbnailSlider: function() {
                $(this.selectors.productThumbs).slick("unslick"), this.settings.sliderActive = !1, $(this.selectors.productThumbsWrapper, this.$container).find('[tabindex="-1"]').removeAttr("tabindex")
            },
            _liveRegionText: function(t) {
                var e = "[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";
                if (!t) return e = theme.strings.unavailable;
                var i = t.available ? "" : theme.strings.soldOut + ",";
                e = e.replace("[Availability]", i);
                var a = "",
                    r = theme.Currency.formatMoney(t.price, theme.moneyFormat),
                    s = "",
                    n = "",
                    o = "",
                    c = "";
                return t.compare_at_price > t.price && (a = theme.strings.regularPrice, r = theme.Currency.formatMoney(t.compare_at_price, theme.moneyFormat) + ",", s = theme.strings.sale, n = theme.Currency.formatMoney(t.price, theme.moneyFormat)), t.unit_price && (o = theme.strings.unitPrice, c = theme.Currency.formatMoney(t.unit_price, theme.moneyFormat) + " " + theme.strings.unitPriceSeparator + " " + this._getBaseUnit(t)), e = e.replace("[Regular]", a).replace("[$$]", r).replace("[Sale]", s).replace("[$]", n).replace("[UnitPrice]", o).replace("[$$$]", c).trim()
            },
            _updateLiveRegion: function(t) {
                var e = t.variant,
                    i = this.container.querySelector(this.selectors.productStatus);
                i.innerHTML = this._liveRegionText(e), i.setAttribute("aria-hidden", !1), setTimeout(function() {
                    i.setAttribute("aria-hidden", !0)
                }, 1e3)
            },
            _updateAddToCart: function(t) {
                var e = t.variant;
                e ? e.available ? (this.$addToCart.removeAttr("aria-disabled").attr("aria-label", theme.strings.addToCart), $(this.selectors.addToCartText, this.$container).text(theme.strings.addToCart), this.$shopifyPaymentButton.show()) : (this.$addToCart.attr("aria-disabled", !0).attr("aria-label", theme.strings.soldOut), $(this.selectors.addToCartText, this.$container).text(theme.strings.soldOut), this.$shopifyPaymentButton.hide()) : (this.$addToCart.attr("aria-disabled", !0).attr("aria-label", theme.strings.unavailable), $(this.selectors.addToCartText, this.$container).text(theme.strings.unavailable), this.$shopifyPaymentButton.hide())
            },
            _updateAvailability: function(t) {
                this._hideErrorMessage(), this._updateAddToCart(t), this._updateLiveRegion(t), this._updatePrice(t)
            },
            _updateImages: function(t) {
                var e = t.variant.featured_image.id;
                this._switchImage(e), this._setActiveThumbnail(e)
            },
            _updatePrice: function(t) {
                var e = t.variant,
                    i = $(this.selectors.priceContainer, this.$container),
                    a = $(this.selectors.regularPrice, i),
                    r = $(this.selectors.salePrice, i),
                    s = $(this.selectors.unitPrice, i),
                    n = $(this.selectors.unitPriceBaseUnit, i);
                if (i.removeClass(this.classes.productUnavailable).removeClass(this.classes.productOnSale).removeClass(this.classes.productUnitAvailable).removeClass(this.classes.productSoldOut).removeAttr("aria-hidden"), this.$productPolicies.removeClass(this.classes.visibilityHidden), !e) return i.addClass(this.classes.productUnavailable).attr("aria-hidden", !0), void this.$productPolicies.addClass(this.classes.visibilityHidden);
                e.available ? (e.compare_at_price > e.price ? (a.html(theme.Currency.formatMoney(e.compare_at_price, theme.moneyFormat)), r.html(theme.Currency.formatMoney(e.price, theme.moneyFormat)), i.addClass(this.classes.productOnSale)) : a.html(theme.Currency.formatMoney(e.price, theme.moneyFormat)), e.unit_price && (s.html(theme.Currency.formatMoney(e.unit_price, theme.moneyFormat)), n.html(this._getBaseUnit(e)), i.addClass(this.classes.productUnitAvailable))) : i.addClass(this.classes.productSoldOut)
            },
            _getBaseUnit: function(t) {
                return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit
            },
            _updateSKU: function(t) {
                var e = t.variant;
                $(this.selectors.SKU).html(e.sku)
            },
            onUnload: function() {
                this.$container.off(this.settings.namespace)
            }
        }), t
    }(), theme.ProductRecommendations = function() {
        return function(t) {
            this.$container = $(t);
            var e = this.$container.data("baseUrl") + "?section_id=product-recommendations&product_id=" + this.$container.data("productId") + "&limit=4";
            $.get(e).then(function(t) {
                var e = $(t).html();
                "" !== e.trim() && this.$container.html(e)
            }.bind(this))
        }
    }(), theme.Quotes = function() {
        var t = {
                mediaQuerySmall: "screen and (max-width: 991px)",
                mediaQueryMediumUp: "screen and (min-width: 992px)",
                slideCount: 0
            },
            e = {
                accessibility: !0,
                arrows: !1,
                dots: !0,
                autoplay: !1,
                touchThreshold: 20,
                slidesToShow: 3,
                slidesToScroll: 3
            };

        function i(i) {
            var a = (this.$container = $(i)).attr("data-section-id"),
                r = this.wrapper = ".quotes-wrapper",
                s = this.slider = "#Quotes-" + a,
                n = $(s, r),
                o = !1,
                c = $.extend({}, e, {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: !0
                });

            function d(t, e) {
                o && (t.slick("unslick"), o = !1), t.slick(e), o = !0
            }
            t.slideCount = n.data("count"), t.slideCount < e.slidesToShow && (e.slidesToShow = t.slideCount, e.slidesToScroll = t.slideCount), n.on("init", this.a11y.bind(this)), enquire.register(t.mediaQuerySmall, {
                match: function() {
                    d(n, c)
                }
            }), enquire.register(t.mediaQueryMediumUp, {
                match: function() {
                    d(n, e)
                }
            })
        }
        return i.prototype = _.assignIn({}, i.prototype, {
            onUnload: function() {
                enquire.unregister(t.mediaQuerySmall), enquire.unregister(t.mediaQueryMediumUp), $(this.slider, this.wrapper).slick("unslick")
            },
            onBlockSelect: function(t) {
                var e = $(".quotes-slide--" + t.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                $(this.slider, this.wrapper).slick("slickGoTo", e)
            },
            a11y: function(t, e) {
                var i = e.$list,
                    a = $(this.wrapper, this.$container);
                i.removeAttr("aria-live"), a.on("focusin", function(t) {
                    a.has(t.target).length && i.attr("aria-live", "polite")
                }), a.on("focusout", function(t) {
                    a.has(t.target).length && i.removeAttr("aria-live")
                })
            }
        }), i
    }(), theme.slideshows = {}, theme.SlideshowSection = function() {
        return function(t) {
            var e = (this.$container = $(t)).attr("data-section-id"),
                i = this.slideshow = "#Slideshow-" + e;
            theme.slideshows[i] = new theme.Slideshow(i, e)
        }
    }(), theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
        onUnload: function() {
            delete theme.slideshows[this.slideshow]
        },
        onBlockSelect: function(t) {
            var e = $(this.slideshow);
            e.data("adapt-height") && theme.slideshows[this.slideshow].setSlideshowHeight();
            var i = $(".slideshow__slide--" + t.detail.blockId + ":not(.slick-cloned)").data("slick-index");
            e.slick("slickGoTo", i).slick("slickPause")
        },
        onBlockDeselect: function() {
            $(this.slideshow).slick("slickPlay")
        }
    }), theme.slideshows = {}, theme.VideoSection = function() {
        return function(t) {
            var e = this.$container = $(t);
            $(".video", e).each(function() {
                var t = $(this);
                theme.Video.init(t), theme.Video.editorLoadVideo(t.attr("id"))
            })
        }
    }(), theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
        onUnload: function() {
            theme.Video.removeEvents()
        }
    }), theme.heros = {}, theme.HeroSection = function() {
        return function(t) {
            var e = (this.$container = $(t)).attr("data-section-id"),
                i = "#Hero-" + e;
            theme.heros[i] = new theme.Hero(i, e)
        }
    }(), $(document).ready(function() {
        var t = new theme.Sections;
        t.register("cart-template", theme.Cart), t.register("product", theme.Product), t.register("collection-template", theme.Filters), t.register("product-template", theme.Product), t.register("header-section", theme.HeaderSection), t.register("map", theme.Maps), t.register("slideshow-section", theme.SlideshowSection), t.register("video-section", theme.VideoSection), t.register("quotes", theme.Quotes), t.register("hero-section", theme.HeroSection), t.register("product-recommendations", theme.ProductRecommendations)
    }), theme.init = function() {
        theme.customerTemplates.init();
        slate.rte.wrapTable({
            $tables: $(".rte table,.custom__item-inner--html table"),
            tableWrapperClass: "scrollable-wrapper"
        });
        slate.rte.wrapIframe({
            $iframes: $('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"],.custom__item-inner--html iframe[src*="youtube.com/embed"],.custom__item-inner--html iframe[src*="player.vimeo"]'),
            iframeWrapperClass: "video-wrapper"
        }), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(t) {
            slate.a11y.pageLinkFocus($(t.currentTarget.hash))
        }), $('a[href="#"]').on("click", function(t) {
            t.preventDefault()
        }), slate.a11y.accessibleLinks({
            messages: {
                newWindow: theme.strings.newWindow,
                external: theme.strings.external,
                newWindowExternal: theme.strings.newWindowExternal
            },
            $links: $("a[href]:not([aria-describedby], .product-single__thumbnail)")
        }), theme.FormStatus.init();
        var t = {
                image: "[data-image]",
                imagePlaceholder: "[data-image-placeholder]",
                imageWithPlaceholderWrapper: "[data-image-with-placeholder-wrapper]",
                lazyloaded: ".lazyloaded"
            },
            e = {
                hidden: "hide"
            };
        $(document).on("lazyloaded", function(i) {
            var a = $(i.target);
            if (a.data("bgset")) {
                var r = a.find(t.lazyloaded);
                r && (a.data("bg") && r.attr("src", a.data("bg")), a.data("alt") && r.attr("alt", a.data("alt")))
            }
            a.is(t.image) && a.closest(t.imageWithPlaceholderWrapper).find(t.imagePlaceholder).addClass(e.hidden)
        }), $(t.image + ".lazyloaded").closest(t.imageWithPlaceholderWrapper).find(t.imagePlaceholder).addClass(e.hidden)
    }, $(theme.init);


$(document).ready(function() {

    let u = window.location.pathname;
    console.log(u);
    // if(u.indexOf('/teracube-thrive') != -1){
    // var observer = new IntersectionObserver(function(entries) {
    // 	// isIntersecting is true when element and viewport are overlapping
    // 	// isIntersecting is false when element and viewport don't overlap
    //   console.log(entries);
    // 	if(entries[0].isIntersecting === true){
    //     let d = document.querySelectorAll(".links-middle li");
    //     d.forEach((e) => { e.querySelector('a').classList.remove('active'); } );
    //     let id = entries[0].target.getAttribute('id');
    //     document.querySelector("a[href='#"+id+"']").classList.add('active');
    //   }  	
    // }, { threshold: [0] });

    // observer.observe(document.querySelector("#shopify-section-product-template-thrive"));
    // observer.observe(document.querySelector("#shopify-section-product-designd-section"));
    // observer.observe(document.querySelector("#shopify-section-product-warranty-section"));
    // observer.observe(document.querySelector("#shopify-section-product-introducing-section"));
    // observer.observe(document.querySelector("#shopify-section-product-compare-section"));
    // observer.observe(document.querySelector("#shopify-section-product-faq-section"));  
    // }

    // $('.swatch-element input').on('change', function() {
    //     let val = $(this).val();
    //     let i = $(this).parents('.swatch').data('option-index');
    //     let varId = $(this).data('varid');
      
    //     var s_price = $('.swatch-element[data-value="'+val+'"]').attr('data-pdpprice');
    //     console.log(val+"="+i);
    //     console.log(s_price);
    //     $('.swatch-element .carrier_price').find('span').eq(1).text(s_price);
    //     // $('.prime_button #container').removeClass('hidden');
    //     // if(varId == 43615297143041){
    //     //   $('.thrive-amzn-div').hide();
    //     // }else{
    //     //   $('.thrive-amzn-div').show();
    //     // }

    //     $("#SingleOptionSelector-" + i).val(val);
        
    //     $('.swatch[data-option-index="' + i + '"] .swatch-element').removeClass('active');
    //     $(this).parents('.swatch-element').addClass('active');
    //     setTimeout(function() {
    //         var sold_out = $('.product-form__cart-submit').attr('aria-label');
    //         if (sold_out == 'Sold out') {
    //        console.log('yessss')
              
    //             $('#BIS_trigger').show();
    //             $('.qtyBox').hide();
    //             $('.product-form__cart-submit').hide();
    //         } else {
    //        console.log('noooo')
              
    //             $('#BIS_trigger').hide();
    //             $('.qtyBox').show();
    //             $('.product-form__cart-submit').show();
    //         }
    //         // $('.pro-main-img').slick('unslick');
    //         $('.product-single__photo').removeClass('hide');
    //         // $('.pro-main-img').slick({
    //         //   slidesToShow: 1,
    //         //   slidesToScroll: 1,
    //         //   dots:true,
    //         //   infinite:false
    //         // });

    //         let button1 = $('.product-form__variants option:selected').data('buywithprime');
    //         let button2 = $('.product-form__variants option:selected').data('buyonamazon');
    //         let button_url = $('.product-form__variants option:selected').data('buyurl');

    //         if (button1 == true) {
    //             $('.prime_button').show();
    //         } else {
    //             $('.prime_button').hide();
    //         }

    //         if (button2 == true) {
    //             $('.amazon_buy_now a').attr('href', button_url);
    //             $('.amazon_buy_now').show();
    //         } else {
    //             $('.amazon_buy_now').hide();
    //         }

    //         // let url = $('.product-form__variants option:selected').data('buyurl');
    //         // let buy_on_amazon = $('.product-form__variants option:selected').data('buyonamazon');
    //         // if(buy_on_amazon == true){
    //         //   $('.buy_on_amazon').show();
    //         //   if(url != undefined){
    //         //     $('.amazon_buy_now').show();
    //         //     $('.buyAmazon a').attr('href', url);
    //         //   }else{
    //         //     $('.amazon_buy_now').hide();
    //         //   }
    //         // }else{
    //         //   $('.buy_on_amazon').hide();
    //         // }

    //         let product = JSON.parse($('#ProductJson-product-template-thrive').text());
    //         $(product.variants).each(function(index, value) {
    //             if (value.id == varId && value.featured_image != null) {
    //                 let slick_go_to = $('[data-image-id="' + value.featured_image.id + '"]').parent().parent().data('slick-index');
    //                 $('.pro-main-img').slick('slickGoTo', slick_go_to);
    //             }
    //         });

    //         $("#SingleOptionSelector-" + i).change();
    //     }, 100);
    // });

      $(document).ready(function() {
          $('.swatch-element input').on('change', handleSwatchChange);
          $('.swatch-element input:checked').trigger('change');
      });
      
      function handleSwatchChange() {
          let $this = $(this);
          let val = $this.val();
          let optionIndex = $this.closest('.swatch').data('option-index');
          let varId = $this.attr('varid');
          let s_price = $this.closest('.swatch-element').attr('data-pdpprice');
      
         // $('.swatch-element .carrier_price span').eq(1).text(s_price);
          updateState(optionIndex, val, $this, varId);
          handleSoldOutState();
          setTimeout(() => {
              updateProductImage(varId);
              triggerOptionSelectorChange(optionIndex);
          }, 100);
      }
      
      function updateState(index, value, element, varId) {
          $(`#SingleOptionSelector-${index}`).val(value);
          $(`.swatch[data-option-index="${index}"] .swatch-element`).removeClass('active');
          element.closest('.swatch-element').addClass('active');
          updateButtonsState();
      }
      
      function handleSoldOutState() {
          setTimeout(() => {
              let isSoldOut = $('.product-form__cart-submit').attr('aria-label') === 'Sold out';
      
              if (isSoldOut) {
                  $('.notify_qe').show();
                  $('.qtyBox').parent().hide();
                  $('.product-form__cart-submit').hide();
              } else {
                  $('.notify_qe').hide();
                  $('.qtyBox').parent().show();
                  $('.product-form__cart-submit').show();
              }
              $('.product-single__photo').removeClass('hide');
          }, 1000);
      }
      
      function updateButtonsState() {
          let selectedOption = $('.product-form__variants option:selected');
          let isBuyWithPrime = selectedOption.data('buywithprime');
          let isBuyOnAmazon = selectedOption.data('buyonamazon');
          let buyUrl = selectedOption.data('buyurl');
      
          //$('.prime_button').toggle(isBuyWithPrime);
          if (isBuyOnAmazon) {
              $('.amazon_buy_now a').attr('href', buyUrl);
              $('.amazon_buy_now').show();
          } else {
              $('.amazon_buy_now').hide();
          }
      }

      function updateProductImage(varId) {
          let product = JSON.parse($('#ProductJson-product-template-thrive').text());
          let variant = product.variants.find(variant => String(variant.id) === String(varId));

          if (variant) {
              let slickIndex = $(`[data-image-id="${variant.featured_media.id}"]`).closest('.slick-slide').data('slick-index');
              $('.pro-main-img').slick('slickGoTo', slickIndex);
          }
      }
      
      function triggerOptionSelectorChange(index) {
          $(`#SingleOptionSelector-${index}`).change();
      }

  
    $('.btn-more-toggle').on('click', function() {
        var text = $(this).text();
        if (text == 'Show More') {
            $('.hide-block-tech').show();
            $(this).html("Show less");
        } else {
            $('.hide-block-tech').hide();
            $(this).html("Show More");
        }
    });
    $('.btn-more-show').on('click', function() {
        var text = $(this).text();
        if (text == 'Show More') {
            $('.hide-block').show();
            $(this).html("Show less");
        } else {
            $('.hide-block').hide();
            $(this).html("Show More");
        }
    });
    $('.btn-more-toggle').on('click', function() {
        $('.btn-more-toggle').toggleClass('show_more');
    });
    $('.btn-more-show').on('click', function() {
        $('.btn-more-show').toggleClass('show_more');
    });
});

// set endpoint and your access key
//        var ip = '51.89.225.174'
$(document).ready(function($) {
  
    //console.log($.cookie("custom_country_code"));
    if (!$.cookie("custom_country_code")) {
        var access_key = '65d5a7b1427d5bb49beeead38759462e';
        $.getJSON("https://api.ipify.org?format=json", function(data) {
                var ip = data.ip;
          console.log(data);
                $.ajax({
                    url: 'https://api.ipstack.com/' + ip + '?access_key=' + access_key,
                    type: 'POST',
                    //async:false,
                    dataType: 'jsonp',
                    success: function(location) {
                        console.log("location", location);
                        console.log("cookie", $.cookie("custom_country_code"));

                        var p = '';
                        switch (location.continent_name) {
                            case "Europe":
                                if (location.country_code == 'GB') {
                                    p = 'UK';
                                }
                                if (location.continent_name == 'Europe' && location.country_code != 'GB') {
                                    p = 'EU';
                                }
                                break;
                            case "North America":
                                if (location.country_code == 'CA') {
                                    p = 'CA';
                                }
                                if (location.country_code == "US") {
                                    p = 'US';
                                }
                                break;
                            default:
                                p = 'Global';
                        } 
                     // console.log(p);
                        if (p != 'Global') {
                            $('#country-select li').each(function(i) {
                                if (($(this).attr('id')) == p) {
                                    $.removeCookie("custom_country_code"); 
                                    $.cookie("custom_country_code", p, {
                                        expires: 1,
                                        path: '/'
                                    });
                                    $(this).addClass('selected');

                                    $("#country-select").children('span').html($(this).html());
                                }
                            });
                        } else {
                            $.removeCookie("custom_country_code"); 
                            $.cookie("custom_country_code", 'Global', {
                                expires: 1,
                                path: '/'
                            });
                            $('#Global').addClass('selected'); 
                            $("#country-select").children('span').html($('#Global').html());
                        }
                        if(p!=''){
                          $("#country-select").find("#"+p).trigger('click');
                          $("#country-select").removeClass("active");
                        }
                        
                        /*
                        if(($(this).attr('id')) == location.country_code){
                          
                          $.cookie("country_code", p, { expires: 1 });
                          $(this).addClass('selected');
                          $("#country-select").children('span').html($(this).html());
                          
                          console.log(p);
                          
                        //} else if (location.country_code =='IN') {
                          //$('#ROW').addClass('selected');
                          //$("#country-select").children('span').html($('#ROW').html());
                        }else{
                          $.cookie("country_code", 'ROW', { expires: 1 });
                          $('#ROW').addClass('selected');
                          $("#country-select").children('span').html($('#ROW').html());
                          //$('#popup1').css({'visibility':'visible', 'opacity':1});
                        }*/

                    },
                    error: function(error) {
                        alert('error; ' + eval(error));
                    }
                });
            })
            .done(function() {
                $('#popup1').css({
                    'visibility': 'hidden',
                    'opacity': 0
                });
            })
            .fail(function() {
                if (($.cookie("custom_country_code")) == undefined) {
                    $('#popup1').css({
                        'visibility': 'visible',
                        'opacity': 1
                    });
                }
            });
    }

    $('#popup1 .close').on('click', function() {
        $('#popup1').css({
            'visibility': 'hidden',
            'opacity': 0
        });
    });

    function DropDown(el) {
        this.dd = el;
        this.placeholder = this.dd.children('span');
        this.opts = this.dd.find('ul.drop li');
        this.val = '';
        this.index = -1;
        this.initEvents();
    }

    DropDown.prototype = {
        initEvents: function() {
            var obj = this;
            obj.dd.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).toggleClass('active');
            });
            obj.opts.on('click', function() {
                var opt = $(this);
                var li_id = opt.attr('id');
                obj.val = opt.text();
                obj.index = opt.index();
                obj.placeholder.text(obj.val);
                opt.siblings().removeClass('selected');
                opt.filter(':contains("' + obj.val + '")').addClass('selected');
              
                teracube_2e_btn(li_id); 
              
                $.removeCookie("custom_country_code");
                $.cookie("custom_country_code", li_id, {
                    expires: 1,
                    path: '/'
                });
                let u = window.location.pathname;
                if (u.indexOf('/teracube-thrive') != -1) {
                    let pc = li_id;
                    if (pc == 'UK' && u != '/products/teracube-thrive-uk') {
                        window.location.href = '/products/teracube-thrive-uk';
                    }
                    if (pc == 'CA' && u != '/products/teracube-thrive-ca') {
                        window.location.href = '/products/teracube-thrive-ca';
                    }
                    if (pc == 'US' && u != '/products/teracube-thrive-us') {
                        window.location.href = '/products/teracube-thrive-us';
                    }
                    if (pc == 'EU' && u != '/products/teracube-thrive-eu') {
                        window.location.href = '/products/teracube-thrive-eu';
                    }
                    if (pc == 'Global' && u != '/products/teracube-thrive-global') {
                        window.location.href = '/products/teracube-thrive-global';
                    }
                }

                if ($('body').hasClass('template-product')) {
                    console.log("template-product", li_id);
                    $('#SingleOptionSelector-0').val(li_id).trigger('change');
                    $('#SingleOptionSelector-2').val(li_id).trigger('change');
                    var val = $('.product-form__variants').val();

                    var getvariantqty = $('.variant-stock[data-variant-id="' + val + '"]').val();
                    var actualvarqty = $('.actual-variant-stock[data-variant-id="' + val + '"]').val();

                    var safetystock = Number(actualvarqty) - Number(getvariantqty);

                    $('input[data-quantity-input]').attr('max', safetystock);

                    $('.variant-description').hide();
                    $('.variant-description[data-variant-id="' + val + '"]').show();
                    $('.available-qty').hide();
                    $('#Quantity-product-template-sales').val("1");

                    // $('.variant-stock').hide();
                    // $('.variant-stock[data-variant-id="'+val+'"]').show();
                }

                $('#popup1').css({
                    'visibility': 'hidden',
                    'opacity': 0
                });
                $("#country-select").children('span').html($(this).html());
                $("#country-select li").removeClass('selected');
                $("#country-select").find('#' + li_id).addClass('selected');

            }).change();
        },
        getValue: function() {
            return this.val;
        },
        getIndex: function() {
            return this.index;
        }
    };

    // teracube 2e Product Page 3 button hide show Code Start
    function teracube_2e_btn(country_id) {
      var is_commown_display = "N";
      $(".teracube_2e_btn").hide();
      $(".teracube_2e_murena_abtn").hide();
      
      if(country_id=='EU'){ 
          is_commown_display = 'Y';
          $("#teracube_2e_murena").show();
          $("#teracube_2e_rent").show(); 
      }else if(country_id=='US' || country_id=='CA' || country_id=='UK' || country_id=='Global'){
          is_commown_display = 'Y';
          $("#teracube_2e_murena").show(); 
      }
      $(".teracube_2e_murena_abtn_"+country_id).show();
      
      if(is_commown_display == 'Y'){
        $.getJSON("https://ipinfo.io", function(data) {
          $(".teracube_2e_commown").hide();
          if(data.country == 'DE'){
            $("#teracube_2e_commown_germany").show();
          } else {
            $("#teracube_2e_commown_all").show();
          }
        });
      } 
   }
    // teracube 2e Product Page 3 button hide show Code End
  
    $(function() {
        // create new variable for each menu
        var dd1 = new DropDown($('#country-select'));
        var dd2 = new DropDown($('#country-select1'));
        $(document).click(function() {
            // close menu on document click
            $('.wrap-drop').removeClass('active');
        });
    });

    $('#country-select li').each(function(i) { 
        if ($(this).attr('id') == $.cookie("custom_country_code")) {
            $("#country-select li").removeClass('selected');
            $(this).addClass('selected');
            $("#country-select").children('span').html($(this).html());
            teracube_2e_btn($(this).attr('id'));
        } else {
            var int_val = $("#country-select .selected").text();
            $("#country-select .init").html(int_val);
        }
    });

    var int_val1 = $('#country-select1 .selected').html();
    $("#country-select1 .init").html(int_val1);
});

var live_url = window.location.href;
var result = live_url.includes('form_type=customer');
var input_val = document.querySelector('#NewsletterForm--footer').value.length;
if (result && input_val != 0) {
    $(document).scrollTop($(document).height());
    $('.already_exist').append('<p class="already_exist_text">You have already subscribed!</p>');
}